var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/constants/constants.ts
var COMMITMENT_TREE_DEPTH, CSCA_TREE_DEPTH, DEFAULT_MAJORITY, DSC_TREE_DEPTH, ID_CARD_ATTESTATION_ID, MAX_BYTES_IN_FIELD, MAX_FORBIDDEN_COUNTRIES_LIST_LENGTH, MAX_PADDED_ECONTENT_LEN, MAX_PADDED_SIGNED_ATTR_LEN, OFAC_TREE_LEVELS, PASSPORT_ATTESTATION_ID, attributeToPosition, attributeToPosition_ID, k_dsc, k_dsc_3072, k_dsc_4096, max_csca_bytes, max_dsc_bytes, n_dsc, n_dsc_3072, n_dsc_4096, n_dsc_ecdsa;
var init_constants = __esm({
  "src/constants/constants.ts"() {
    COMMITMENT_TREE_DEPTH = 33;
    CSCA_TREE_DEPTH = 12;
    DEFAULT_MAJORITY = "18";
    DSC_TREE_DEPTH = 21;
    ID_CARD_ATTESTATION_ID = "2";
    MAX_BYTES_IN_FIELD = 31;
    MAX_FORBIDDEN_COUNTRIES_LIST_LENGTH = 40;
    MAX_PADDED_ECONTENT_LEN = {
      sha1: 384,
      sha224: 512,
      sha256: 512,
      sha384: 768,
      sha512: 896
    };
    MAX_PADDED_SIGNED_ATTR_LEN = {
      sha1: 128,
      sha224: 128,
      sha256: 256,
      sha384: 256,
      sha512: 256
    };
    OFAC_TREE_LEVELS = 64;
    PASSPORT_ATTESTATION_ID = "1";
    attributeToPosition = {
      issuing_state: [2, 4],
      name: [5, 43],
      passport_number: [44, 52],
      nationality: [54, 56],
      date_of_birth: [57, 62],
      gender: [64, 64],
      expiry_date: [65, 70],
      older_than: [88, 89],
      ofac: [90, 90]
    };
    attributeToPosition_ID = {
      issuing_state: [2, 4],
      name: [60, 89],
      passport_number: [5, 13],
      nationality: [45, 47],
      date_of_birth: [30, 35],
      gender: [37, 37],
      expiry_date: [38, 43],
      older_than: [90, 91],
      ofac: [92, 92]
    };
    k_dsc = 35;
    k_dsc_3072 = 35;
    k_dsc_4096 = 35;
    max_csca_bytes = 1792;
    max_dsc_bytes = 1792;
    n_dsc = 120;
    n_dsc_3072 = 120;
    n_dsc_4096 = 120;
    n_dsc_ecdsa = 64;
  }
});

// src/utils/circuits/uuid.ts
function stringToAsciiBigIntArray(str) {
  const asciiBigIntArray = [];
  for (let i = 0; i < str.length; i++) {
    asciiBigIntArray.push(BigInt(str.charCodeAt(i)));
  }
  return asciiBigIntArray;
}
var init_uuid = __esm({
  "src/utils/circuits/uuid.ts"() {
  }
});

// src/utils/bytes.ts
function bytesToBigDecimal(arr) {
  let result = BigInt(0);
  for (let i = 0; i < arr.length; i++) {
    result = result * BigInt(256) + BigInt(arr[i] & 255);
  }
  return result.toString();
}
function computeIntChunkLength(byteLength) {
  const packSize = MAX_BYTES_IN_FIELD;
  const remain = byteLength % packSize;
  let numChunks = (byteLength - remain) / packSize;
  if (remain > 0) {
    numChunks += 1;
  }
  return numChunks;
}
function hexToDecimal(hex) {
  return BigInt(`0x${hex}`).toString();
}
function hexToSignedBytes(hexString) {
  const bytes = [];
  for (let i = 0; i < hexString.length - 1; i += 2) {
    const byte = parseInt(hexString.substr(i, 2), 16);
    bytes.push(byte >= 128 ? byte - 256 : byte);
  }
  return bytes;
}
function packBytes(unpacked) {
  const bytesCount = [31, 31, 31];
  const packed = [0n, 0n, 0n];
  let byteIndex = 0;
  for (let i = 0; i < bytesCount.length; i++) {
    for (let j = 0; j < bytesCount[i]; j++) {
      if (byteIndex < unpacked.length) {
        packed[i] |= BigInt(unpacked[byteIndex]) << BigInt(j) * 8n;
      }
      byteIndex++;
    }
  }
  return packed;
}
function packBytesArray(unpacked) {
  const packSize = MAX_BYTES_IN_FIELD;
  const maxBytes = unpacked.length;
  const maxInts = computeIntChunkLength(maxBytes);
  const out = new Array(maxInts).fill(0n);
  for (let i = 0; i < maxInts; i++) {
    let sum = 0n;
    for (let j = 0; j < packSize; j++) {
      const idx = packSize * i + j;
      if (idx >= maxBytes) {
        continue;
      } else if (j === 0) {
        sum = BigInt(unpacked[idx]);
      } else {
        sum += (1n << BigInt(8 * j)) * BigInt(unpacked[idx]);
      }
    }
    out[i] = sum;
  }
  return out;
}
function splitToWords(number, wordsize, numberElement) {
  let t = number;
  const words = [];
  for (let i = 0; i < numberElement; ++i) {
    const baseTwo = BigInt(2);
    words.push(`${t % BigInt(Math.pow(Number(baseTwo), wordsize))}`);
    t = BigInt(t / BigInt(Math.pow(Number(BigInt(2)), wordsize)));
  }
  if (!(t == BigInt(0))) {
    throw `Number ${number} does not fit in ${(wordsize * numberElement).toString()} bits`;
  }
  return words;
}
var init_bytes = __esm({
  "src/utils/bytes.ts"() {
    init_constants();
  }
});

// src/utils/hash.ts
import { ethers } from "ethers";
import { sha1 } from "js-sha1";
import { sha224, sha256 } from "js-sha256";
import { sha384, sha512 } from "js-sha512";
import * as forge from "node-forge";
import {
  poseidon1,
  poseidon2,
  poseidon3,
  poseidon4,
  poseidon5,
  poseidon6,
  poseidon7,
  poseidon8,
  poseidon9,
  poseidon10,
  poseidon11,
  poseidon12,
  poseidon13,
  poseidon14,
  poseidon15,
  poseidon16
} from "poseidon-lite";
function calculateUserIdentifierHash(destChainID, userID, userDefinedData) {
  const solidityPackedUserContextData = getSolidityPackedUserContextData(
    destChainID,
    userID,
    userDefinedData
  );
  const inputBytes = Buffer.from(solidityPackedUserContextData.slice(2), "hex");
  const sha256Hash = ethers.sha256(inputBytes);
  const ripemdHash = ethers.ripemd160(sha256Hash);
  return BigInt(ripemdHash);
}
function customHasher(pubKeyFormatted) {
  if (pubKeyFormatted.length < 16) {
    return flexiblePoseidon(pubKeyFormatted.map(BigInt)).toString();
  } else {
    const rounds = Math.ceil(pubKeyFormatted.length / 16);
    if (rounds > 16) {
      throw new Error("Number of rounds is greater than 16");
    }
    const hash2 = new Array(rounds);
    for (let i = 0; i < rounds; i++) {
      hash2[i] = { inputs: new Array(16).fill(BigInt(0)) };
    }
    for (let i = 0; i < rounds; i++) {
      for (let j = 0; j < 16; j++) {
        if (i * 16 + j < pubKeyFormatted.length) {
          hash2[i].inputs[j] = BigInt(pubKeyFormatted[i * 16 + j]);
        }
      }
    }
    const finalHash = flexiblePoseidon(hash2.map((h) => poseidon16(h.inputs)));
    return finalHash.toString();
  }
}
function flexiblePoseidon(inputs) {
  switch (inputs.length) {
    case 1:
      return poseidon1(inputs);
    case 2:
      return poseidon2(inputs);
    case 3:
      return poseidon3(inputs);
    case 4:
      return poseidon4(inputs);
    case 5:
      return poseidon5(inputs);
    case 6:
      return poseidon6(inputs);
    case 7:
      return poseidon7(inputs);
    case 8:
      return poseidon8(inputs);
    case 9:
      return poseidon9(inputs);
    case 10:
      return poseidon10(inputs);
    case 11:
      return poseidon11(inputs);
    case 12:
      return poseidon12(inputs);
    case 13:
      return poseidon13(inputs);
    case 14:
      return poseidon14(inputs);
    case 15:
      return poseidon15(inputs);
    case 16:
      return poseidon16(inputs);
    default:
      throw new Error(`Unsupported number of inputs: ${inputs.length}`);
  }
}
function getSolidityPackedUserContextData(destChainID, userID, userDefinedData) {
  const userIdHex = userID.replace(/-/g, "");
  return ethers.solidityPacked(
    ["bytes32", "bytes32", "bytes"],
    [
      ethers.zeroPadValue(ethers.toBeHex(destChainID), 32),
      ethers.zeroPadValue(userIdHex.startsWith("0x") ? userIdHex : "0x" + userIdHex, 32),
      ethers.toUtf8Bytes(userDefinedData)
    ]
  );
}
function hash(hashFunction, bytesArray, format = "bytes") {
  const unsignedBytesArray = bytesArray.map((byte) => byte & 255);
  let hashResult;
  switch (hashFunction) {
    case "sha1":
      hashResult = sha1(unsignedBytesArray);
      break;
    case "sha224":
      hashResult = sha224(unsignedBytesArray);
      break;
    case "sha256":
      hashResult = sha256(unsignedBytesArray);
      break;
    case "sha384":
      hashResult = sha384(unsignedBytesArray);
      break;
    case "sha512":
      hashResult = sha512(unsignedBytesArray);
      break;
    default:
      console.log("\x1B[31m%s\x1B[0m", `${hashFunction} not found in hash`);
      hashResult = sha256(unsignedBytesArray);
  }
  if (format === "hex") {
    return hashResult;
  }
  if (format === "bytes") {
    return hexToSignedBytes(hashResult);
  }
  const actualForgeUtil = forge.util ? forge.util : forge.default.util;
  if (format === "binary") {
    return actualForgeUtil.binary.raw.encode(new Uint8Array(hexToSignedBytes(hashResult)));
  }
  throw new Error(`Invalid format: ${format}`);
}
function packBytesAndPoseidon(unpacked) {
  const packed = packBytesArray(unpacked);
  return customHasher(packed.map(String)).toString();
}
var init_hash = __esm({
  "src/utils/hash.ts"() {
    init_bytes();
  }
});

// src/utils/certificate_parsing/parseCertificateSimple.ts
import * as asn1js from "asn1js";
import { Certificate, RSAPublicKey, RSASSAPSSParams } from "pkijs";
function getCertificateFromPem(pemContent) {
  const pemFormatted = pemContent.replace(/(-----(BEGIN|END) CERTIFICATE-----|\n|\r)/g, "");
  const binary = Buffer.from(pemFormatted, "base64");
  const arrayBuffer = new ArrayBuffer(binary.length);
  const view = new Uint8Array(arrayBuffer);
  for (let i = 0; i < binary.length; i++) {
    view[i] = binary[i];
  }
  const asn12 = asn1js.fromBER(arrayBuffer);
  if (asn12.offset === -1) {
    throw new Error(`ASN.1 parsing error: ${asn12.result.error}`);
  }
  return new Certificate({ schema: asn12.result });
}
var init_parseCertificateSimple = __esm({
  "src/utils/certificate_parsing/parseCertificateSimple.ts"() {
  }
});

// src/utils/circuits/formatInputs.ts
function formatCountriesList(countries3) {
  if (countries3.length > MAX_FORBIDDEN_COUNTRIES_LIST_LENGTH) {
    throw new Error(
      `Countries list must be inferior or equals to ${MAX_FORBIDDEN_COUNTRIES_LIST_LENGTH}`
    );
  }
  for (const country of countries3) {
    if (!country || country.length !== 3) {
      throw new Error(
        `Invalid country code: "${country}". Country codes must be exactly 3 characters long.`
      );
    }
  }
  const paddedCountries = countries3.concat(
    Array(MAX_FORBIDDEN_COUNTRIES_LIST_LENGTH - countries3.length).fill("")
  );
  const result = paddedCountries.flatMap((country) => {
    const chars = country.padEnd(3, "\0").split("").map((char) => char.charCodeAt(0));
    return chars;
  });
  return result;
}
var init_formatInputs = __esm({
  "src/utils/circuits/formatInputs.ts"() {
    init_constants();
  }
});

// src/utils/date.ts
function getCurrentDateYYMMDD(dayDiff = 0) {
  const date = /* @__PURE__ */ new Date();
  date.setDate(date.getDate() + dayDiff);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const YY = `0${year % 100}`.slice(-2);
  const MM = `0${month}`.slice(-2);
  const DD = `0${day}`.slice(-2);
  const yymmdd = `${YY}${MM}${DD}`;
  return Array.from(yymmdd).map((char) => parseInt(char));
}
var init_date = __esm({
  "src/utils/date.ts"() {
  }
});

// src/utils/passports/format.ts
function formatMrz(mrz) {
  const mrzCharcodes = [...mrz].map((char) => char.charCodeAt(0));
  if (mrz.length === 88) {
    mrzCharcodes.unshift(88);
    mrzCharcodes.unshift(95, 31);
    mrzCharcodes.unshift(91);
    mrzCharcodes.unshift(97);
  } else if (mrz.length === 90) {
    mrzCharcodes.unshift(90);
    mrzCharcodes.unshift(95, 31);
    mrzCharcodes.unshift(93);
    mrzCharcodes.unshift(97);
  } else {
    throw new Error(`Unsupported MRZ length: ${mrz.length}. Expected 88 or 90 characters.`);
  }
  return mrzCharcodes;
}
var init_format = __esm({
  "src/utils/passports/format.ts"() {
  }
});

// src/utils/circuits/generateInputs.ts
function findIndexInTree(tree, commitment) {
  let index = tree.indexOf(commitment);
  if (index === -1) {
    index = tree.indexOf(commitment.toString());
  }
  if (index === -1) {
    throw new Error("This commitment was not found in the tree");
  } else {
  }
  return index;
}
function formatInput(input) {
  if (Array.isArray(input)) {
    return input.map((item) => BigInt(item).toString());
  } else if (input instanceof Uint8Array) {
    return Array.from(input).map((num) => BigInt(num).toString());
  } else if (typeof input === "string" && input.includes(",")) {
    const numbers = input.split(",").map((s) => s.trim()).filter((s) => s !== "" && !isNaN(Number(s))).map(Number);
    try {
      return numbers.map((num) => BigInt(num).toString());
    } catch (e) {
      throw e;
    }
  } else {
    return [BigInt(input).toString()];
  }
}
function generateCircuitInputsDSC(passportData, serializedCscaTree) {
  const passportMetadata = passportData.passportMetadata;
  const cscaParsed = passportData.csca_parsed;
  const dscParsed = passportData.dsc_parsed;
  const raw_dsc = passportData.dsc;
  const cscaTbsBytesPadded = padWithZeroes(cscaParsed.tbsBytes, max_csca_bytes);
  const dscTbsBytes = dscParsed.tbsBytes;
  const [dscTbsBytesPadded, dscTbsBytesLen] = pad(passportMetadata.cscaHashFunction)(
    dscTbsBytes,
    max_dsc_bytes
  );
  const leaf = getLeafCscaTree(cscaParsed);
  const [root, path, siblings] = getCscaTreeInclusionProof(leaf, serializedCscaTree);
  const csca_pubKey_formatted = getCertificatePubKey(
    cscaParsed,
    passportMetadata.cscaSignatureAlgorithm,
    passportMetadata.cscaHashFunction
  );
  const signatureRaw = extractSignatureFromDSC(raw_dsc);
  const signature = formatSignatureDSCCircuit(
    passportMetadata.cscaSignatureAlgorithm,
    passportMetadata.cscaHashFunction,
    cscaParsed,
    signatureRaw
  );
  const [startIndex, keyLength] = findStartPubKeyIndex(
    cscaParsed,
    cscaTbsBytesPadded,
    passportMetadata.cscaSignatureAlgorithm
  );
  return {
    raw_csca: cscaTbsBytesPadded.map((x) => x.toString()),
    raw_csca_actual_length: BigInt(cscaParsed.tbsBytes.length).toString(),
    csca_pubKey_offset: startIndex.toString(),
    csca_pubKey_actual_size: BigInt(keyLength).toString(),
    raw_dsc: Array.from(dscTbsBytesPadded).map((x) => x.toString()),
    raw_dsc_padded_length: BigInt(dscTbsBytesLen).toString(),
    // with the sha padding actually
    csca_pubKey: csca_pubKey_formatted,
    signature,
    merkle_root: root,
    path,
    siblings
  };
}
function generateCircuitInputsRegister(secret, passportData, serializedDscTree) {
  const { mrz, eContent, signedAttr } = passportData;
  const passportMetadata = passportData.passportMetadata;
  const dscParsed = passportData.dsc_parsed;
  const [dscTbsBytesPadded] = pad(dscParsed.hashAlgorithm)(dscParsed.tbsBytes, max_dsc_bytes);
  const { pubKey, signature, signatureAlgorithmFullName } = getPassportSignatureInfos(passportData);
  const mrz_formatted = formatMrz(mrz);
  if (eContent.length > MAX_PADDED_ECONTENT_LEN[signatureAlgorithmFullName]) {
    console.error(
      `eContent too long (${eContent.length} bytes). Max length is ${MAX_PADDED_ECONTENT_LEN[signatureAlgorithmFullName]} bytes.`
    );
    throw new Error(
      `This length of datagroups (${eContent.length} bytes) is currently unsupported. Please contact us so we add support!`
    );
  }
  const [eContentPadded, eContentLen] = pad(passportMetadata.eContentHashFunction)(
    eContent,
    MAX_PADDED_ECONTENT_LEN[passportMetadata.dg1HashFunction]
  );
  const [signedAttrPadded, signedAttrPaddedLen] = pad(passportMetadata.signedAttrHashFunction)(
    signedAttr,
    MAX_PADDED_SIGNED_ATTR_LEN[passportMetadata.eContentHashFunction]
  );
  const dsc_leaf = getLeafDscTree(dscParsed, passportData.csca_parsed);
  const [root, path, siblings, leaf_depth] = getDscTreeInclusionProof(dsc_leaf, serializedDscTree);
  const csca_tree_leaf = getLeafCscaTree(passportData.csca_parsed);
  const [startIndex, keyLength] = findStartPubKeyIndex(
    dscParsed,
    dscTbsBytesPadded,
    dscParsed.signatureAlgorithm
  );
  const inputs = {
    raw_dsc: dscTbsBytesPadded.map((x) => x.toString()),
    raw_dsc_actual_length: [BigInt(dscParsed.tbsBytes.length).toString()],
    dsc_pubKey_offset: startIndex,
    dsc_pubKey_actual_size: [BigInt(keyLength).toString()],
    dg1: mrz_formatted,
    dg1_hash_offset: passportMetadata.dg1HashOffset,
    eContent: eContentPadded,
    eContent_padded_length: eContentLen,
    signed_attr: signedAttrPadded,
    signed_attr_padded_length: signedAttrPaddedLen,
    signed_attr_econtent_hash_offset: passportMetadata.eContentHashOffset,
    pubKey_dsc: pubKey,
    signature_passport: signature,
    merkle_root: [BigInt(root).toString()],
    leaf_depth,
    path,
    siblings,
    csca_tree_leaf,
    secret
  };
  return Object.entries(inputs).map(([key, value]) => ({
    [key]: formatInput(value)
  })).reduce((acc, curr) => ({ ...acc, ...curr }), {});
}
function generateCircuitInputsVCandDisclose(secret, attestation_id, passportData, scope, selector_dg1, selector_older_than, merkletree, majority, passportNo_smt, nameAndDob_smt, nameAndYob_smt, selector_ofac, forbidden_countries_list, user_identifier) {
  const { mrz, eContent, signedAttr, documentType } = passportData;
  const passportMetadata = passportData.passportMetadata;
  const isPassportType = documentType === "passport" || documentType === "mock_passport";
  const formattedMrz = formatMrz(mrz);
  const eContent_shaBytes = hash(
    passportMetadata.eContentHashFunction,
    Array.from(eContent),
    "bytes"
  );
  const eContent_packed_hash = packBytesAndPoseidon(
    eContent_shaBytes.map((byte) => byte & 255)
  );
  const dsc_tree_leaf = getLeafDscTree(passportData.dsc_parsed, passportData.csca_parsed);
  const commitment = generateCommitment(secret, attestation_id, passportData);
  const index = findIndexInTree(merkletree, BigInt(commitment));
  const { siblings, path, leaf_depth } = generateMerkleProof(
    merkletree,
    index,
    COMMITMENT_TREE_DEPTH
  );
  const formattedMajority = majority.length === 1 ? `0${majority}` : majority;
  const majority_ascii = formattedMajority.split("").map((char) => char.charCodeAt(0));
  const defaultSiblings = Array(OFAC_TREE_LEVELS).fill(BigInt(0));
  let passportNoProof = {
    root: BigInt(0),
    closestleaf: BigInt(0),
    siblings: defaultSiblings
  };
  let nameDobProof;
  let nameYobProof;
  const nameSlice = isPassportType ? formattedMrz.slice(10, 49) : formattedMrz.slice(65, 95);
  const dobSlice = isPassportType ? formattedMrz.slice(62, 68) : formattedMrz.slice(35, 41);
  const yobSlice = isPassportType ? formattedMrz.slice(62, 64) : formattedMrz.slice(35, 37);
  const nationalitySlice = isPassportType ? formattedMrz.slice(59, 62) : formattedMrz.slice(50, 53);
  const passNoSlice = isPassportType ? formattedMrz.slice(49, 58) : formattedMrz.slice(10, 19);
  const namedob_leaf = getNameDobLeaf(nameSlice, dobSlice);
  const nameyob_leaf = getNameYobLeaf(nameSlice, yobSlice);
  nameDobProof = generateSMTProof(nameAndDob_smt, namedob_leaf);
  nameYobProof = generateSMTProof(nameAndYob_smt, nameyob_leaf);
  if (isPassportType) {
    if (!passportNo_smt) {
      console.warn("Document type is passport, but passportNo_smt tree was not provided.");
    } else {
      const passportNo_leaf = getPassportNumberAndNationalityLeaf(passNoSlice, nationalitySlice);
      const proofResult = generateSMTProof(passportNo_smt, passportNo_leaf);
      passportNoProof = {
        root: BigInt(proofResult.root),
        closestleaf: BigInt(proofResult.closestleaf),
        siblings: proofResult.siblings
      };
    }
  }
  const baseInputs = {
    secret: formatInput(secret),
    attestation_id: formatInput(attestation_id),
    dg1: formatInput(formattedMrz),
    eContent_shaBytes_packed_hash: formatInput(eContent_packed_hash),
    dsc_tree_leaf: formatInput(dsc_tree_leaf),
    merkle_root: formatInput(merkletree.root),
    leaf_depth: formatInput(leaf_depth),
    path: formatInput(path),
    siblings: formatInput(siblings),
    selector_dg1: formatInput(selector_dg1),
    selector_older_than: formatInput(selector_older_than),
    scope: formatInput(scope),
    current_date: formatInput(getCurrentDateYYMMDD()),
    majority: formatInput(majority_ascii),
    user_identifier: formatInput(user_identifier),
    selector_ofac: formatInput(selector_ofac),
    forbidden_countries_list: formatInput(formatCountriesList(forbidden_countries_list))
  };
  const ofacNameInputs = {
    ofac_namedob_smt_root: formatInput(nameDobProof.root),
    ofac_namedob_smt_leaf_key: formatInput(nameDobProof.closestleaf),
    ofac_namedob_smt_siblings: formatInput(nameDobProof.siblings),
    ofac_nameyob_smt_root: formatInput(nameYobProof.root),
    ofac_nameyob_smt_leaf_key: formatInput(nameYobProof.closestleaf),
    ofac_nameyob_smt_siblings: formatInput(nameYobProof.siblings)
  };
  const finalInputs = {
    ...baseInputs,
    ...ofacNameInputs,
    ...isPassportType && {
      ofac_passportno_smt_root: formatInput(passportNoProof.root),
      ofac_passportno_smt_leaf_key: formatInput(passportNoProof.closestleaf),
      ofac_passportno_smt_siblings: formatInput(passportNoProof.siblings)
    }
  };
  return finalInputs;
}
var init_generateInputs = __esm({
  "src/utils/circuits/generateInputs.ts"() {
    init_constants();
    init_date();
    init_hash();
    init_format();
    init_passport();
    init_trees();
    init_formatInputs();
  }
});

// src/utils/shaPad.ts
function assert(cond, errorMessage) {
  if (!cond) {
    throw new Error(errorMessage);
  }
}
function int64toBytes(num) {
  const arr = new ArrayBuffer(8);
  const view = new DataView(arr);
  view.setInt32(4, num, false);
  return new Uint8Array(arr);
}
function int128toBytes(x) {
  const buffer = new ArrayBuffer(16);
  const view = new DataView(buffer);
  view.setBigUint64(0, BigInt(0), false);
  view.setBigUint64(8, BigInt(x), false);
  return new Uint8Array(buffer);
}
function int8toBytes(num) {
  const arr = new ArrayBuffer(1);
  const view = new DataView(arr);
  view.setUint8(0, num);
  return new Uint8Array(arr);
}
function mergeUInt8Arrays(a1, a2) {
  const mergedArray = new Uint8Array(a1.length + a2.length);
  mergedArray.set(a1);
  mergedArray.set(a2, a1.length);
  return new Uint8Array(mergedArray.buffer);
}
function sha384_512Pad(prehash_prepad_m_array, maxShaBytes) {
  let prehash_prepad_m = new Uint8Array(prehash_prepad_m_array);
  const length_bits = prehash_prepad_m.length * 8;
  const length_in_bytes = int128toBytes(length_bits);
  prehash_prepad_m = mergeUInt8Arrays(prehash_prepad_m, int8toBytes(2 ** 7));
  while ((prehash_prepad_m.length * 8 + length_in_bytes.length * 8) % 1024 !== 0) {
    prehash_prepad_m = mergeUInt8Arrays(prehash_prepad_m, int8toBytes(0));
  }
  prehash_prepad_m = mergeUInt8Arrays(prehash_prepad_m, length_in_bytes);
  assert(prehash_prepad_m.length * 8 % 1024 === 0, "Padding did not complete properly!");
  const messageLen = prehash_prepad_m.length;
  while (prehash_prepad_m.length < maxShaBytes) {
    prehash_prepad_m = mergeUInt8Arrays(prehash_prepad_m, int128toBytes(0));
  }
  assert(
    prehash_prepad_m.length === maxShaBytes,
    `Padding to max length did not complete properly! Your padded message is ${prehash_prepad_m.length} long but max is ${maxShaBytes}!`
  );
  return [Array.from(prehash_prepad_m), messageLen];
}
function shaPad(prehash_prepad_m_array, maxShaBytes) {
  let prehash_prepad_m = new Uint8Array(prehash_prepad_m_array);
  const length_bits = prehash_prepad_m.length * 8;
  const length_in_bytes = int64toBytes(length_bits);
  prehash_prepad_m = mergeUInt8Arrays(prehash_prepad_m, int8toBytes(2 ** 7));
  while ((prehash_prepad_m.length * 8 + length_in_bytes.length * 8) % 512 !== 0) {
    prehash_prepad_m = mergeUInt8Arrays(prehash_prepad_m, int8toBytes(0));
  }
  prehash_prepad_m = mergeUInt8Arrays(prehash_prepad_m, length_in_bytes);
  assert(prehash_prepad_m.length * 8 % 512 === 0, "Padding did not complete properly!");
  const messageLen = prehash_prepad_m.length;
  while (prehash_prepad_m.length < maxShaBytes) {
    prehash_prepad_m = mergeUInt8Arrays(prehash_prepad_m, int64toBytes(0));
  }
  assert(
    prehash_prepad_m.length === maxShaBytes,
    `Padding to max length did not complete properly! Your padded message is ${prehash_prepad_m.length} long but max is ${maxShaBytes}!`
  );
  return [Array.from(prehash_prepad_m), messageLen];
}
var init_shaPad = __esm({
  "src/utils/shaPad.ts"() {
  }
});

// src/utils/aadhaar/assets/dataInput.ts
var testQRData;
var init_dataInput = __esm({
  "src/utils/aadhaar/assets/dataInput.ts"() {
    testQRData = {
      testQRData: "8259163575998395410294216884136380576185817320339145460288951755287582961380611852552428987321584902318624273479337130653734982789439199350807739714406680256506601030028361685736660257517232716829232450159251789263870750283214820475102793105777087762238893090228084052270739203426767272062178826235941508196284529472654271516164224874687419158221021213944829682919423174703783469927383220474654008065915029614141226522064062660593170425792840873655513538373377850112144063189928583588899889878172757870400281696669604010659786496608127700010264443115263361656744433002559396889060190428705316366290450741550935385486607346514118464415324976934593027192262025619948063647667007927187736245772179085671658409804311603784752615097922989017361163561315974008304022542448394278143245816470881130080719485003834016131185071765229491892891069788319670287394271744730364788949609836924781874523936880888005883165757273872375006288978183466996520618718348187182821516617721340861010989807614756396013627238651856164981477576514065364628430139194213240602981419233621531616776712580234318576148789862972873366521755587675635811636464535551028275057950562020714225333126426609311459495088802145911084644641596208432517247324679678535859879970296810837735288916946197174410518342751033634782712968162882714769666441813893046220965525694847349131353986974388432968669605721975441870936552792275255624723251162192468002453471184713983574359601113515796454264270501379717344206777921353459767049560942843350534472442799601294637063232419543855742825887931841338302499933012059977947394755335155868283405337181095220998277373266658634859632929226320059674299759100792654417315629048732480315019941928105082550091217622422743467170706956093632228513797781797454779203616427853022505097310749994766657051986303478622173767936568165644251615127773430128638507677775244195799780291921828512257290767451475181728141544788756907393883042588060697683541401090581157249784874529424005078918452607589129440476242749110421616270676359722523229311894327359615548588038186027827017569331332262329182564217789843145105509621002324556840213928256545454178891208004109769624959566302976213521762873815749009289995208912424872527724417047936432945498377307452190302923489092664437908497749093491199476080757200233878726847198496754472664256996743796092233459542884818717466621372105594672115988382565552756801323160697003960485232732393383241422077506009076922303757067128564302338914230360252223406874457414109774901980252709597099278192874164252010830754720603092419792069707099362278082792090307065378744856387301364608460967253691290230861162587170799141457093188189022390589265654613500974699477990974878105678883229707694455342266695530373994049224098435972125150350136428446936271698977517627416435999970351222450833295217051468307037908262231982382247410542334757724852032521780157518474618653527191342825230455100778913195115477763082159513429761573752871477695723697689470263993132596482716347199834315782099668846081963760553679915994617396376870314998926788197388410764535427795200340714967872713095483294486407886767431404892448155562283436571050452251042117926586451385682519188252281397"
    };
  }
});

// src/utils/aadhaar/constants.ts
function createSelector(fieldsToReveal) {
  const bits = Array(119).fill(0);
  for (const field of fieldsToReveal) {
    if (field === "MINIMUM_AGE_VALID") {
      continue;
    }
    const selectorBits = SELECTOR_BITS[field];
    for (const bit of selectorBits) {
      bits[bit] = 1;
    }
  }
  let result = 0n;
  for (let i = 0; i < 121; i++) {
    if (bits[i]) {
      result += 1n << BigInt(i);
    }
  }
  return result;
}
var MAX_FIELD_BYTE_SIZE, NAME_MAX_LENGTH, FIELD_LENGTHS, REVEAL_DATA_INDICES, REVEAL_DATA_END_INDICES, REVEAL_DATA_RANGES, SELECTOR_BITS, COMMON_FIELD_COMBINATIONS;
var init_constants2 = __esm({
  "src/utils/aadhaar/constants.ts"() {
    MAX_FIELD_BYTE_SIZE = 31;
    NAME_MAX_LENGTH = 2 * MAX_FIELD_BYTE_SIZE;
    FIELD_LENGTHS = {
      GENDER: 1,
      YEAR_OF_BIRTH: 4,
      MONTH_OF_BIRTH: 2,
      DAY_OF_BIRTH: 2,
      NAME: NAME_MAX_LENGTH,
      // 62
      AADHAAR_LAST_4_DIGITS: 4,
      PINCODE: 6,
      STATE: MAX_FIELD_BYTE_SIZE,
      // 31
      PHONE_LAST_4_DIGITS: 4,
      OFAC_NAME_DOB_CHECK: 1,
      OFAC_NAME_YOB_CHECK: 1,
      MINIMUM_AGE_VALID: 1
    };
    REVEAL_DATA_INDICES = {
      GENDER: 0,
      YEAR_OF_BIRTH_START: 1,
      MONTH_OF_BIRTH_START: 5,
      DAY_OF_BIRTH_START: 7,
      NAME_START: 9,
      AADHAAR_LAST_4_DIGITS_START: 71,
      PINCODE_START: 75,
      STATE_START: 81,
      PHONE_LAST_4_DIGITS_START: 112,
      OFAC_NAME_DOB_CHECK: 116,
      OFAC_NAME_YOB_CHECK: 117,
      MINIMUM_AGE_VALID: 118,
      // Note: Always revealed, no selector control
      OFAC_NAME_DOB_REVERSE_CHECK: 119,
      OFAC_NAME_YOB_REVERSE_CHECK: 120
    };
    REVEAL_DATA_END_INDICES = {
      GENDER: REVEAL_DATA_INDICES.GENDER + FIELD_LENGTHS.GENDER,
      YEAR_OF_BIRTH_END: REVEAL_DATA_INDICES.YEAR_OF_BIRTH_START + FIELD_LENGTHS.YEAR_OF_BIRTH,
      MONTH_OF_BIRTH_END: REVEAL_DATA_INDICES.MONTH_OF_BIRTH_START + FIELD_LENGTHS.MONTH_OF_BIRTH,
      DAY_OF_BIRTH_END: REVEAL_DATA_INDICES.DAY_OF_BIRTH_START + FIELD_LENGTHS.DAY_OF_BIRTH,
      NAME_END: REVEAL_DATA_INDICES.NAME_START + FIELD_LENGTHS.NAME,
      AADHAAR_LAST_4_DIGITS_END: REVEAL_DATA_INDICES.AADHAAR_LAST_4_DIGITS_START + FIELD_LENGTHS.AADHAAR_LAST_4_DIGITS,
      PINCODE_END: REVEAL_DATA_INDICES.PINCODE_START + FIELD_LENGTHS.PINCODE,
      STATE_END: REVEAL_DATA_INDICES.STATE_START + FIELD_LENGTHS.STATE,
      PHONE_LAST_4_DIGITS_END: REVEAL_DATA_INDICES.PHONE_LAST_4_DIGITS_START + FIELD_LENGTHS.PHONE_LAST_4_DIGITS,
      OFAC_NAME_DOB_CHECK_END: REVEAL_DATA_INDICES.OFAC_NAME_DOB_CHECK + FIELD_LENGTHS.OFAC_NAME_DOB_CHECK,
      OFAC_NAME_YOB_CHECK_END: REVEAL_DATA_INDICES.OFAC_NAME_YOB_CHECK + FIELD_LENGTHS.OFAC_NAME_YOB_CHECK,
      MINIMUM_AGE_VALID_END: REVEAL_DATA_INDICES.MINIMUM_AGE_VALID + FIELD_LENGTHS.MINIMUM_AGE_VALID
    };
    REVEAL_DATA_RANGES = {
      GENDER: [REVEAL_DATA_INDICES.GENDER, REVEAL_DATA_END_INDICES.GENDER],
      YEAR_OF_BIRTH: [
        REVEAL_DATA_INDICES.YEAR_OF_BIRTH_START,
        REVEAL_DATA_END_INDICES.YEAR_OF_BIRTH_END
      ],
      MONTH_OF_BIRTH: [
        REVEAL_DATA_INDICES.MONTH_OF_BIRTH_START,
        REVEAL_DATA_END_INDICES.MONTH_OF_BIRTH_END
      ],
      DAY_OF_BIRTH: [
        REVEAL_DATA_INDICES.DAY_OF_BIRTH_START,
        REVEAL_DATA_END_INDICES.DAY_OF_BIRTH_END
      ],
      NAME: [REVEAL_DATA_INDICES.NAME_START, REVEAL_DATA_END_INDICES.NAME_END],
      AADHAAR_LAST_4_DIGITS: [
        REVEAL_DATA_INDICES.AADHAAR_LAST_4_DIGITS_START,
        REVEAL_DATA_END_INDICES.AADHAAR_LAST_4_DIGITS_END
      ],
      PINCODE: [REVEAL_DATA_INDICES.PINCODE_START, REVEAL_DATA_END_INDICES.PINCODE_END],
      STATE: [REVEAL_DATA_INDICES.STATE_START, REVEAL_DATA_END_INDICES.STATE_END],
      PHONE_LAST_4_DIGITS: [
        REVEAL_DATA_INDICES.PHONE_LAST_4_DIGITS_START,
        REVEAL_DATA_END_INDICES.PHONE_LAST_4_DIGITS_END
      ],
      OFAC_NAME_DOB_CHECK: [
        REVEAL_DATA_INDICES.OFAC_NAME_DOB_CHECK,
        REVEAL_DATA_END_INDICES.OFAC_NAME_DOB_CHECK_END
      ],
      OFAC_NAME_YOB_CHECK: [
        REVEAL_DATA_INDICES.OFAC_NAME_YOB_CHECK,
        REVEAL_DATA_END_INDICES.OFAC_NAME_YOB_CHECK_END
      ],
      MINIMUM_AGE_VALID: [
        REVEAL_DATA_INDICES.MINIMUM_AGE_VALID,
        REVEAL_DATA_END_INDICES.MINIMUM_AGE_VALID_END
      ]
    };
    SELECTOR_BITS = {
      GENDER: [0],
      YEAR_OF_BIRTH: [1, 2, 3, 4],
      MONTH_OF_BIRTH: [5, 6],
      DAY_OF_BIRTH: [7, 8],
      NAME: Array.from({ length: NAME_MAX_LENGTH }, (_, i) => i + 9),
      // indices 9-70
      AADHAAR_LAST_4_DIGITS: [71, 72, 73, 74],
      PINCODE: [75, 76, 77, 78, 79, 80],
      STATE: Array.from({ length: MAX_FIELD_BYTE_SIZE }, (_, i) => i + 81),
      // indices 81-111
      PHONE_LAST_4_DIGITS: [112, 113, 114, 115],
      PHOTO_HASH: [116],
      // This uses sel_bits[116] for reveal_photoHash output
      OFAC_NAME_DOB_CHECK: [117],
      // revealData[116] uses sel_bits[117]
      OFAC_NAME_YOB_CHECK: [118]
      // revealData[117] uses sel_bits[118]
      // Note: MINIMUM_AGE_VALID has NO selector bit - always revealed (revealData[118])
    };
    COMMON_FIELD_COMBINATIONS = {
      BASIC_INFO: ["GENDER", "YEAR_OF_BIRTH", "MONTH_OF_BIRTH", "DAY_OF_BIRTH"],
      IDENTITY: ["NAME", "YEAR_OF_BIRTH", "MONTH_OF_BIRTH", "DAY_OF_BIRTH"],
      LOCATION: ["STATE", "PINCODE"],
      CONTACT: ["PHONE_LAST_4_DIGITS"],
      OFAC_CHECKS: ["OFAC_NAME_DOB_CHECK", "OFAC_NAME_YOB_CHECK"],
      // Note: ALL_FIELDS excludes MINIMUM_AGE_VALID since it's always revealed and has no selector bit
      ALL_SELECTABLE_FIELDS: Object.keys(FIELD_LENGTHS).filter(
        (field) => field !== "MINIMUM_AGE_VALID"
      ),
      ALL_FIELDS: Object.keys(FIELD_LENGTHS)
    };
  }
});

// src/utils/aadhaar/utils.ts
import { ethers as ethers2 } from "ethers";
import forge2 from "node-forge";
import {
  convertBigIntToByteArray,
  decompressByteArray,
  extractPhoto,
  getEndIndex,
  getRandomBytes,
  IdFields,
  rawDataToCompressedQR,
  replaceBytesBetween,
  returnFullId
} from "@anon-aadhaar/core";
function calculateAge(dob, mob, yob) {
  const currentDate = /* @__PURE__ */ new Date();
  const currentYear = currentDate.getUTCFullYear();
  const currentMonth = currentDate.getUTCMonth() + 1;
  const currentDay = currentDate.getUTCDate();
  const birthYear = parseInt(yob);
  const birthMonth = parseInt(mob);
  const birthDay = parseInt(dob);
  let age = currentYear - birthYear;
  if (currentMonth < birthMonth || currentMonth === birthMonth && currentDay < birthDay) {
    age--;
  }
  return {
    age,
    currentYear,
    currentMonth,
    currentDay
  };
}
function extractQRDataFields(qrData) {
  let qrDataBytes;
  if (typeof qrData === "string") {
    qrDataBytes = convertBigIntToByteArray(BigInt(qrData));
  } else {
    qrDataBytes = qrData;
  }
  const decodedData = decompressByteArray(qrDataBytes);
  const signedData = decodedData.slice(0, decodedData.length - 256);
  const delimiterIndices = [];
  for (let i = 0; i < signedData.length; i++) {
    if (signedData[i] === 255) {
      delimiterIndices.push(i);
      if (delimiterIndices.length === 18) {
        break;
      }
    }
  }
  if (delimiterIndices.length < 18) {
    throw new Error(`Insufficient delimiters found: ${delimiterIndices.length}/18`);
  }
  const aadhaarLast4Digits = asciiArrayToString([
    signedData[5],
    signedData[6],
    signedData[7],
    signedData[8]
  ]);
  const nameData = extractFieldData(signedData, delimiterIndices, FIELD_POSITIONS.NAME);
  const name = asciiArrayToString(nameData).trim();
  const dobData = extractFieldData(signedData, delimiterIndices, FIELD_POSITIONS.DOB);
  const dob = asciiArrayToString([dobData[0], dobData[1]]);
  const mob = asciiArrayToString([dobData[3], dobData[4]]);
  const yob = asciiArrayToString([dobData[6], dobData[7], dobData[8], dobData[9]]);
  const genderData = extractFieldData(signedData, delimiterIndices, FIELD_POSITIONS.GENDER);
  const gender = asciiArrayToString(genderData);
  const pincodeData = extractFieldData(signedData, delimiterIndices, FIELD_POSITIONS.PINCODE);
  const pincode = asciiArrayToString(pincodeData);
  const stateData = extractFieldData(signedData, delimiterIndices, FIELD_POSITIONS.STATE);
  const state = asciiArrayToString(stateData).trim();
  const phoneData = extractFieldData(signedData, delimiterIndices, FIELD_POSITIONS.PHONE_NO);
  const phoneNoLast4Digits = asciiArrayToString(phoneData.slice(phoneData.length - 4));
  const timestampYear = asciiArrayToString([
    signedData[9],
    signedData[10],
    signedData[11],
    signedData[12]
  ]);
  const timestampMonth = asciiArrayToString([signedData[13], signedData[14]]);
  const timestampDay = asciiArrayToString([signedData[15], signedData[16]]);
  const timestampHour = asciiArrayToString([signedData[17], signedData[18]]);
  const timestampMinute = asciiArrayToString([signedData[19], signedData[20]]);
  const timestamp = `${timestampYear}-${timestampMonth}-${timestampDay} ${timestampHour}:${timestampMinute}`;
  return {
    name,
    yob,
    mob,
    dob,
    gender,
    pincode,
    state,
    aadhaarLast4Digits,
    phoneNoLast4Digits,
    timestamp
  };
}
function returnNewDateString(timestamp) {
  const newDate = timestamp ? /* @__PURE__ */ new Date(+timestamp) : /* @__PURE__ */ new Date();
  const offsetHours = 5;
  const offsetMinutes = 30;
  newDate.setUTCHours(newDate.getUTCHours() + offsetHours);
  newDate.setUTCMinutes(newDate.getUTCMinutes() + offsetMinutes);
  return newDate.getUTCFullYear().toString() + (newDate.getUTCMonth() + 1).toString().padStart(2, "0") + newDate.getUTCDate().toString().padStart(2, "0") + newDate.getUTCHours().toString().padStart(2, "0") + newDate.getUTCMinutes().toString().padStart(2, "0") + newDate.getUTCSeconds().toString().padStart(2, "0") + newDate.getUTCMilliseconds().toString().padStart(3, "0");
}
function asciiArrayToString(asciiArray) {
  return asciiArray.filter((byte) => byte !== 0).map((byte) => String.fromCharCode(byte)).join("");
}
function extractFieldData(data, delimiterIndices, position) {
  const startIndex = delimiterIndices[position - 1] + 1;
  const endIndex = delimiterIndices[position];
  const fieldData = [];
  for (let i = startIndex; i < endIndex; i++) {
    fieldData.push(data[i]);
  }
  return fieldData;
}
function stringToAsciiArray(str) {
  return str.split("").map((char) => char.charCodeAt(0));
}
var FIELD_POSITIONS, signNewTestData, createCustomV2TestData, generateTestData, testCustomData;
var init_utils = __esm({
  "src/utils/aadhaar/utils.ts"() {
    FIELD_POSITIONS = {
      REFERENCE_ID: 2,
      NAME: 3,
      DOB: 4,
      GENDER: 5,
      PINCODE: 11,
      STATE: 13,
      PHONE_NO: 17,
      PHOTO: 18
    };
    signNewTestData = (newSignedData, privKeyPem) => {
      try {
        const privateKey = forge2.pki.privateKeyFromPem(privKeyPem);
        const md = forge2.md.sha256.create();
        md.update(forge2.util.binary.raw.encode(newSignedData));
        const signature = privateKey.sign(md);
        const signatureBytes = forge2.util.binary.raw.decode(signature);
        return new Uint8Array(signatureBytes);
      } catch (error) {
        console.error("Failed to sign data with forge:", error);
        throw new Error(`Signing failed: ${error}`);
      }
    };
    createCustomV2TestData = ({
      signedData,
      dob,
      pincode,
      gender,
      state,
      photo,
      name,
      timestamp,
      aadhaarLast4Digits
    }) => {
      const allDataParsed = [];
      const delimiterIndices = [];
      let countDelimiter = 0;
      let temp = [];
      for (let i = 0; i < signedData.length; i++) {
        if (countDelimiter < 16) {
          if (signedData[i] !== 255) {
            temp.push(signedData[i]);
          } else {
            countDelimiter += 1;
            allDataParsed.push(temp);
            delimiterIndices.push(i);
            temp = [];
          }
        } else {
          break;
        }
      }
      console.log("createCustomV2TestData", {
        signedData,
        dob,
        pincode,
        gender,
        state,
        photo,
        name,
        timestamp,
        aadhaarLast4Digits
      });
      const newDateString = returnNewDateString(timestamp);
      const newTimestamp = new TextEncoder().encode(newDateString);
      const signedDataWithNewTimestamp = replaceBytesBetween(
        signedData,
        newTimestamp,
        6,
        5 + newTimestamp.length
      );
      let modifiedSignedData = signedDataWithNewTimestamp;
      if (dob) {
        const newDOB = new TextEncoder().encode(dob);
        modifiedSignedData = replaceBytesBetween(
          modifiedSignedData,
          newDOB,
          delimiterIndices[IdFields.DOB - 1] + 1,
          delimiterIndices[IdFields.DOB - 1] + allDataParsed[IdFields.DOB].length
        );
      }
      if (gender) {
        const newGender = new TextEncoder().encode(gender);
        modifiedSignedData = replaceBytesBetween(
          modifiedSignedData,
          newGender,
          delimiterIndices[IdFields.Gender - 1] + 1,
          delimiterIndices[IdFields.Gender - 1] + allDataParsed[IdFields.Gender].length
        );
      }
      if (pincode) {
        const newPincode = new TextEncoder().encode(pincode);
        modifiedSignedData = replaceBytesBetween(
          modifiedSignedData,
          newPincode,
          delimiterIndices[IdFields.PinCode - 1] + 1,
          delimiterIndices[IdFields.PinCode - 1] + allDataParsed[IdFields.PinCode].length
        );
      }
      if (state) {
        const newState = new TextEncoder().encode(state);
        modifiedSignedData = replaceBytesBetween(
          modifiedSignedData,
          newState,
          delimiterIndices[IdFields.State - 1] + 1,
          delimiterIndices[IdFields.State - 1] + allDataParsed[IdFields.State].length
        );
      }
      if (!aadhaarLast4Digits) {
        for (let i = 2; i < 6; i++) {
          modifiedSignedData[i] = Math.floor(Math.random() * 10) + 48;
        }
      }
      if (name) {
        const newName = new TextEncoder().encode(name);
        modifiedSignedData = replaceBytesBetween(
          modifiedSignedData,
          newName,
          delimiterIndices[IdFields.Name - 1] + 1,
          delimiterIndices[IdFields.Name - 1] + allDataParsed[IdFields.Name].length
        );
      }
      if (photo) {
        const { begin, dataLength } = extractPhoto(
          Array.from(modifiedSignedData),
          modifiedSignedData.length
        );
        const photoLength = dataLength - begin;
        modifiedSignedData = replaceBytesBetween(
          modifiedSignedData,
          getRandomBytes(photoLength - 1),
          begin + 1,
          begin + photoLength - 1
        );
      }
      const versionSpecifier = new Uint8Array([86, 50, 255]);
      const number1234 = new Uint8Array([49, 50, 51, 52, 255]);
      const beforeInsertion = new Uint8Array(
        modifiedSignedData.slice(0, getEndIndex(modifiedSignedData))
      );
      const afterInsertion = new Uint8Array(modifiedSignedData.slice(getEndIndex(modifiedSignedData)));
      const newData = new Uint8Array(
        versionSpecifier.length + beforeInsertion.length + number1234.length + afterInsertion.length
      );
      newData.set(versionSpecifier, 0);
      newData.set(beforeInsertion, versionSpecifier.length);
      newData.set(number1234, versionSpecifier.length + beforeInsertion.length);
      newData.set(afterInsertion, versionSpecifier.length + beforeInsertion.length + number1234.length);
      return newData;
    };
    generateTestData = ({
      privKeyPem,
      data,
      dob,
      gender,
      pincode,
      state,
      photo,
      name,
      timestamp
    }) => {
      const qrDataBytes = convertBigIntToByteArray(BigInt(data));
      const decodedData = decompressByteArray(qrDataBytes);
      const dataToSign = createCustomV2TestData({
        signedData: decodedData.slice(0, decodedData.length - 256),
        dob,
        pincode,
        gender,
        state,
        photo,
        name,
        timestamp
      });
      const signature = signNewTestData(dataToSign, privKeyPem);
      const tempData = Buffer.concat([dataToSign, signature]);
      const newCompressedData = rawDataToCompressedQR(tempData);
      const newQrData = {
        testQRData: newCompressedData.toString(),
        ...returnFullId(dataToSign)
      };
      return newQrData;
    };
    testCustomData = "2374971804270526477833002468783965837992554564899874087591661303561346432389832047870524302186901344489362368642972767716416349990805756094923115719687656090691368051627957878187788907419297818953295185555346288172578594637886352753543271000481717080003254556962148594350559820352806251787713278744047402230989238559317351232114240089849934148895256488140236015024800731753594740948640957680138566468247224859669467819596919398964809164399637893729212452791889199675715949918925838319591794702333094022248132120531152523331442741730158840977243402215102904932650832502847295644794421419704633765033761284508863534321317394686768650111457751139630853448637215423705157211510636160227953566227527799608082928846103264491539001327407775670834868948113753614112563650255058316849200536533335903554984254814901522086937767458409075617572843449110393213525925388131214952874629655799772119820372255291052673056372346072235458198199995637720424196884145247220163810790179386390283738429482893152518286247124911446073389185062482901364671389605727763080854673156754021728522287806275420847159574631844674460263574901590412679291518508010087116598357407343835408554094619585212373168435612645646129147973594416508676872819776522537778717985070402222824965034768103900739105784663244748432502180989441389718131079445941981681118258324511923246198334046020123727749408128519721102477302359413240175102907322619462289965085963377744024233678337951462006962521823224880199210318367946130004264196899778609815012001799773327514133268825910089483612283510244566484854597156100473055413090101948456959122378865704840756793122956663218517626099291311352417342899623681483097817511136427210593032393600010728324905512596767095096153856032112835755780472808814199620390836980020899858288860556611564167406292139646289142056168261133256777093245980048335918156712295254776487472431445495668303900536289283098315798552328294391152828182614909451410115516297083658174657554955228963550255866282688308751041517464999930825273776417639569977754844191402927594739069037851707477839207593911886893016618794870530622356073909077832279869798641545167528509966656120623184120128052588408742941658045827255866966100249857968956536613250770326334844204927432961924987891433020671754710428050564671868464658436926086493709176888821257183419013229795869757265111599482263223604228286513011751601176504567030118257385997460972803240338899836840030438830725520798480181575861397469056536579877274090338750406459700907704031830137890544492015701251066934352867527112361743047684237105216779177819594030160887368311805926405114938744235859610328064947158936962470654636736991567663705830950312548447653861922078087824048793236971354828540758657075837209006713701763902429652486225300535997260665898927924843608750347193892239342462507130025307878412116604096773706728162016134101751551184021079984480254041743057914746472840768175369369852937574401874295943063507273467384747124843744395375119899278823903202010381949145094804675442110869084589592876721655764753871572233276245590041302887094585204427900634246823674277680009401177473636685542700515621164233992970974893989913447733956146698563285998205950467321954304";
  }
});

// src/utils/aadhaar/mockData.ts
var mockData_exports = {};
__export(mockData_exports, {
  computeCommitment: () => computeCommitment,
  computePackedCommitment: () => computePackedCommitment,
  convertByteArrayToBigInt: () => convertByteArrayToBigInt,
  nullifierHash: () => nullifierHash,
  prepareAadhaarDiscloseData: () => prepareAadhaarDiscloseData,
  prepareAadhaarDiscloseTestData: () => prepareAadhaarDiscloseTestData,
  prepareAadhaarRegisterData: () => prepareAadhaarRegisterData,
  prepareAadhaarRegisterTestData: () => prepareAadhaarRegisterTestData,
  processQRData: () => processQRData,
  processQRDataSimple: () => processQRDataSimple
});
import forge3 from "node-forge";
import { poseidon5 as poseidon52 } from "poseidon-lite";
import {
  convertBigIntToByteArray as convertBigIntToByteArray2,
  decompressByteArray as decompressByteArray2,
  extractPhoto as extractPhoto2,
  splitToWords as splitToWords2
} from "@anon-aadhaar/core";
import { bufferToHex, Uint8ArrayToCharArray } from "@zk-email/helpers/dist/binary-format.js";
function computePaddedName(name) {
  return name.padEnd(62, "\0").split("").map((char) => char.charCodeAt(0));
}
function computeCommitment(secret, qrHash, nullifier, packedCommitment, photoHash) {
  return poseidon52([secret, qrHash, nullifier, packedCommitment, photoHash]);
}
function computePackedCommitment(extractedFields) {
  const packedCommitmentArgs = [
    3,
    ...stringToAsciiArray(extractedFields.pincode),
    ...stringToAsciiArray(extractedFields.state.padEnd(31, "\0")),
    ...stringToAsciiArray(extractedFields.phoneNoLast4Digits),
    ...stringToAsciiArray(extractedFields.name.padEnd(62, "\0"))
  ];
  return BigInt(packBytesAndPoseidon(packedCommitmentArgs));
}
function convertByteArrayToBigInt(byteArray) {
  let result = 0n;
  for (let i = 0; i < byteArray.length; i++) {
    result = result * 256n + BigInt(byteArray[i]);
  }
  return result;
}
function nullifierHash(extractedFields) {
  const genderAscii = stringToAsciiArray(extractedFields.gender)[0];
  const personalInfoHashArgs = [
    genderAscii,
    ...stringToAsciiArray(extractedFields.yob),
    ...stringToAsciiArray(extractedFields.mob),
    ...stringToAsciiArray(extractedFields.dob),
    ...stringToAsciiArray(extractedFields.name.toUpperCase().padEnd(62, "\0")),
    ...stringToAsciiArray(extractedFields.aadhaarLast4Digits)
  ];
  return BigInt(packBytesAndPoseidon(personalInfoHashArgs));
}
function prepareAadhaarDiscloseData(qrData, identityTree, nameAndDob_smt, nameAndYob_smt, scope, secret, user_identifier, discloseAttributes) {
  const sharedData = processQRDataSimple(qrData);
  const { currentYear, currentMonth, currentDay } = calculateAge(
    sharedData.extractedFields.dob,
    sharedData.extractedFields.mob,
    sharedData.extractedFields.yob
  );
  const genderAscii = stringToAsciiArray(sharedData.extractedFields.gender)[0];
  const nullifier = nullifierHash(sharedData.extractedFields);
  const packedCommitment = computePackedCommitment(sharedData.extractedFields);
  const commitment = computeCommitment(
    BigInt(secret),
    BigInt(sharedData.qrHash),
    nullifier,
    packedCommitment,
    BigInt(sharedData.photoHash)
  );
  const paddedName = computePaddedName(sharedData.extractedFields.name);
  const index = findIndexInTree(identityTree, BigInt(commitment));
  const {
    siblings,
    path: merkle_path,
    leaf_depth
  } = generateMerkleProof(identityTree, index, COMMITMENT_TREE_DEPTH);
  const namedob_leaf = getNameDobLeafAadhaar(
    sharedData.extractedFields.name,
    sharedData.extractedFields.yob,
    sharedData.extractedFields.mob,
    sharedData.extractedFields.dob
  );
  const nameyob_leaf = getNameYobLeafAahaar(
    sharedData.extractedFields.name,
    sharedData.extractedFields.yob
  );
  const {
    root: ofac_name_dob_smt_root,
    closestleaf: ofac_name_dob_smt_leaf_key,
    siblings: ofac_name_dob_smt_siblings
  } = generateSMTProof(nameAndDob_smt, namedob_leaf);
  const {
    root: ofac_name_yob_smt_root,
    closestleaf: ofac_name_yob_smt_leaf_key,
    siblings: ofac_name_yob_smt_siblings
  } = generateSMTProof(nameAndYob_smt, nameyob_leaf);
  const selectorArr = [];
  if (discloseAttributes.dateOfBirth) {
    selectorArr.push("YEAR_OF_BIRTH");
    selectorArr.push("MONTH_OF_BIRTH");
    selectorArr.push("DAY_OF_BIRTH");
  }
  if (discloseAttributes.name) {
    selectorArr.push("NAME");
  }
  if (discloseAttributes.gender) {
    selectorArr.push("GENDER");
  }
  if (discloseAttributes.idNumber) {
    selectorArr.push("AADHAAR_LAST_4_DIGITS");
  }
  if (discloseAttributes.issuingState) {
    selectorArr.push("STATE");
  }
  if (discloseAttributes.ofac) {
    selectorArr.push("OFAC_NAME_DOB_CHECK");
    selectorArr.push("OFAC_NAME_YOB_CHECK");
  }
  const selector = createSelector(selectorArr);
  const inputs = {
    attestation_id: "3",
    secret,
    qrDataHash: formatInput(BigInt(sharedData.qrHash)),
    gender: formatInput(genderAscii),
    yob: stringToAsciiArray(sharedData.extractedFields.yob),
    mob: stringToAsciiArray(sharedData.extractedFields.mob),
    dob: stringToAsciiArray(sharedData.extractedFields.dob),
    name: formatInput(paddedName),
    aadhaar_last_4digits: stringToAsciiArray(sharedData.extractedFields.aadhaarLast4Digits),
    pincode: stringToAsciiArray(sharedData.extractedFields.pincode),
    state: stringToAsciiArray(sharedData.extractedFields.state.padEnd(31, "\0")),
    ph_no_last_4digits: stringToAsciiArray(sharedData.extractedFields.phoneNoLast4Digits),
    photoHash: formatInput(BigInt(sharedData.photoHash)),
    merkle_root: formatInput(BigInt(identityTree.root)),
    leaf_depth: formatInput(leaf_depth),
    path: formatInput(merkle_path),
    siblings: formatInput(siblings),
    ofac_name_dob_smt_leaf_key: formatInput(BigInt(ofac_name_dob_smt_leaf_key)),
    ofac_name_dob_smt_root: formatInput(BigInt(ofac_name_dob_smt_root)),
    ofac_name_dob_smt_siblings: formatInput(ofac_name_dob_smt_siblings),
    ofac_name_yob_smt_leaf_key: formatInput(BigInt(ofac_name_yob_smt_leaf_key)),
    ofac_name_yob_smt_root: formatInput(BigInt(ofac_name_yob_smt_root)),
    ofac_name_yob_smt_siblings: formatInput(ofac_name_yob_smt_siblings),
    selector: formatInput(selector),
    minimumAge: formatInput(discloseAttributes.minimumAge ?? 0),
    currentYear: formatInput(currentYear),
    currentMonth: formatInput(currentMonth),
    currentDay: formatInput(currentDay),
    scope: formatInput(BigInt(scope)),
    user_identifier: formatInput(BigInt(user_identifier)),
    forbidden_countries_list: discloseAttributes.forbiddenCountriesListPacked ? formatInput(formatCountriesList(discloseAttributes.forbiddenCountriesListPacked)) : formatInput([...Array(120)].map((_) => "0"))
  };
  return inputs;
}
function prepareAadhaarDiscloseTestData(privateKeyPem, merkletree, nameAndDob_smt, nameAndYob_smt, scope, secret, user_identifier, selector, name, dateOfBirth, gender, pincode, state, timestamp, updateTree) {
  const sharedData = processQRData(
    privateKeyPem,
    name,
    dateOfBirth,
    gender,
    pincode,
    state,
    timestamp
  );
  const { age, currentYear, currentMonth, currentDay } = calculateAge(
    sharedData.extractedFields.dob,
    sharedData.extractedFields.mob,
    sharedData.extractedFields.yob
  );
  const genderAscii = stringToAsciiArray(sharedData.extractedFields.gender)[0];
  const nullifier = nullifierHash(sharedData.extractedFields);
  const packedCommitment = computePackedCommitment(sharedData.extractedFields);
  const commitment = computeCommitment(
    BigInt(secret),
    BigInt(sharedData.qrHash),
    nullifier,
    packedCommitment,
    BigInt(sharedData.photoHash)
  );
  const paddedName = computePaddedName(sharedData.extractedFields.name);
  if (updateTree) {
    merkletree.insert(BigInt(commitment));
  }
  const index = findIndexInTree(merkletree, BigInt(commitment));
  const {
    siblings,
    path: merkle_path,
    leaf_depth
  } = generateMerkleProof(merkletree, index, COMMITMENT_TREE_DEPTH);
  const namedob_leaf = getNameDobLeafAadhaar(
    sharedData.extractedFields.name,
    sharedData.extractedFields.yob,
    sharedData.extractedFields.mob,
    sharedData.extractedFields.dob
  );
  const nameyob_leaf = getNameYobLeafAahaar(
    sharedData.extractedFields.name,
    sharedData.extractedFields.yob
  );
  const {
    root: ofac_name_dob_smt_root,
    closestleaf: ofac_name_dob_smt_leaf_key,
    siblings: ofac_name_dob_smt_siblings
  } = generateSMTProof(nameAndDob_smt, namedob_leaf);
  const {
    root: ofac_name_yob_smt_root,
    closestleaf: ofac_name_yob_smt_leaf_key,
    siblings: ofac_name_yob_smt_siblings
  } = generateSMTProof(nameAndYob_smt, nameyob_leaf);
  const inputs = {
    attestation_id: "3",
    secret,
    qrDataHash: BigInt(sharedData.qrHash).toString(),
    gender: genderAscii.toString(),
    yob: stringToAsciiArray(sharedData.extractedFields.yob),
    mob: stringToAsciiArray(sharedData.extractedFields.mob),
    dob: stringToAsciiArray(sharedData.extractedFields.dob),
    name: formatInput(paddedName),
    aadhaar_last_4digits: stringToAsciiArray(sharedData.extractedFields.aadhaarLast4Digits),
    pincode: stringToAsciiArray(sharedData.extractedFields.pincode),
    state: stringToAsciiArray(sharedData.extractedFields.state.padEnd(31, "\0")),
    ph_no_last_4digits: stringToAsciiArray(sharedData.extractedFields.phoneNoLast4Digits),
    photoHash: formatInput(BigInt(sharedData.photoHash)),
    merkle_root: formatInput(BigInt(merkletree.root)),
    leaf_depth: formatInput(leaf_depth),
    path: formatInput(merkle_path),
    siblings: formatInput(siblings),
    ofac_name_dob_smt_leaf_key: formatInput(BigInt(ofac_name_dob_smt_leaf_key)),
    ofac_name_dob_smt_root: formatInput(BigInt(ofac_name_dob_smt_root)),
    ofac_name_dob_smt_siblings: formatInput(ofac_name_dob_smt_siblings),
    ofac_name_yob_smt_leaf_key: formatInput(BigInt(ofac_name_yob_smt_leaf_key)),
    ofac_name_yob_smt_root: formatInput(BigInt(ofac_name_yob_smt_root)),
    ofac_name_yob_smt_siblings: formatInput(ofac_name_yob_smt_siblings),
    selector,
    minimumAge: formatInput(age - 2),
    currentYear: formatInput(currentYear),
    currentMonth: formatInput(currentMonth),
    currentDay: formatInput(currentDay),
    scope: formatInput(BigInt(scope)),
    user_identifier: formatInput(BigInt(user_identifier)),
    forbidden_countries_list: [...Array(120)].map((x) => "0")
  };
  return {
    inputs,
    nullifier,
    commitment
  };
}
async function prepareAadhaarRegisterData(qrData, secret, certs) {
  const sharedData = processQRDataSimple(qrData);
  const delimiterIndices = [];
  for (let i = 0; i < sharedData.qrDataPadded.length; i++) {
    if (sharedData.qrDataPadded[i] === 255) {
      delimiterIndices.push(i);
    }
    if (delimiterIndices.length === 18) {
      break;
    }
  }
  let photoEOI = 0;
  for (let i = delimiterIndices[17]; i < sharedData.qrDataPadded.length - 1; i++) {
    if (sharedData.qrDataPadded[i + 1] === 217 && sharedData.qrDataPadded[i] === 255) {
      photoEOI = i + 1;
    }
  }
  if (photoEOI === 0) {
    throw new Error("Photo EOI not found");
  }
  const signatureBytes = sharedData.decodedData.slice(
    sharedData.decodedData.length - 256,
    sharedData.decodedData.length
  );
  const signature = BigInt("0x" + bufferToHex(Buffer.from(signatureBytes)).toString());
  const certificates = await Promise.all(
    certs.map(async (cert2) => {
      const certificate = forge3.pki.certificateFromPem(cert2);
      const publicKey = certificate.publicKey;
      try {
        const md = forge3.md.sha256.create();
        md.update(forge3.util.binary.raw.encode(sharedData.signedData));
        const isValid = publicKey.verify(md.digest().getBytes(), signatureBytes);
        return isValid;
      } catch (error) {
        return false;
      }
    })
  );
  const validCert = certificates.indexOf(true);
  if (validCert === -1) {
    throw new Error("No valid certificate found");
  }
  const certPem = certs[validCert];
  const cert = forge3.pki.certificateFromPem(certPem);
  const modulusHex = cert.publicKey.n.toString(16);
  const pubKey = BigInt("0x" + modulusHex);
  const nullifier = nullifierHash(sharedData.extractedFields);
  const packedCommitment = computePackedCommitment(sharedData.extractedFields);
  const commitment = computeCommitment(
    BigInt(secret),
    BigInt(sharedData.qrHash),
    nullifier,
    packedCommitment,
    BigInt(sharedData.photoHash)
  );
  const inputs = {
    qrDataPadded: Uint8ArrayToCharArray(sharedData.qrDataPadded),
    qrDataPaddedLength: sharedData.qrDataPaddedLen,
    delimiterIndices,
    signature: splitToWords2(signature, BigInt(121), BigInt(17)),
    pubKey: splitToWords2(pubKey, BigInt(121), BigInt(17)),
    secret,
    photoEOI
  };
  return inputs;
}
function prepareAadhaarRegisterTestData(privKeyPem, pubkeyPem, secret, name, dateOfBirth, gender, pincode, state, timestamp) {
  const sharedData = processQRData(
    privKeyPem,
    name,
    dateOfBirth,
    gender,
    pincode,
    state,
    timestamp
  );
  const delimiterIndices = [];
  for (let i = 0; i < sharedData.qrDataPadded.length; i++) {
    if (sharedData.qrDataPadded[i] === 255) {
      delimiterIndices.push(i);
    }
    if (delimiterIndices.length === 18) {
      break;
    }
  }
  let photoEOI = 0;
  for (let i = delimiterIndices[17]; i < sharedData.qrDataPadded.length - 1; i++) {
    if (sharedData.qrDataPadded[i + 1] === 217 && sharedData.qrDataPadded[i] === 255) {
      photoEOI = i + 1;
    }
  }
  if (photoEOI === 0) {
    throw new Error("Photo EOI not found");
  }
  const signatureBytes = sharedData.decodedData.slice(
    sharedData.decodedData.length - 256,
    sharedData.decodedData.length
  );
  const signature = BigInt("0x" + bufferToHex(Buffer.from(signatureBytes)).toString());
  const publicKey = forge3.pki.publicKeyFromPem(pubkeyPem);
  const modulusHex = publicKey.n.toString(16);
  const pubKey = BigInt("0x" + modulusHex);
  const nullifier = nullifierHash(sharedData.extractedFields);
  const packedCommitment = computePackedCommitment(sharedData.extractedFields);
  const commitment = computeCommitment(
    BigInt(secret),
    BigInt(sharedData.qrHash),
    nullifier,
    packedCommitment,
    BigInt(sharedData.photoHash)
  );
  const inputs = {
    qrDataPadded: Uint8ArrayToCharArray(sharedData.qrDataPadded),
    qrDataPaddedLength: sharedData.qrDataPaddedLen,
    delimiterIndices,
    signature: splitToWords2(signature, BigInt(121), BigInt(17)),
    pubKey: splitToWords2(pubKey, BigInt(121), BigInt(17)),
    secret,
    photoEOI
  };
  return {
    inputs,
    nullifier,
    commitment
  };
}
function processQRData(privKeyPem, name, dateOfBirth, gender, pincode, state, timestamp) {
  const finalName = name ?? "Sumit Kumar";
  const finalDateOfBirth = dateOfBirth ?? "01-01-1984";
  const finalGender = gender ?? "M";
  const finalPincode = pincode ?? "110051";
  const finalState = state ?? "Delhi";
  let QRData;
  if (name || dateOfBirth || gender || pincode || state) {
    const newTestData = generateTestData({
      privKeyPem,
      data: testCustomData,
      name: finalName,
      dob: finalDateOfBirth,
      gender: finalGender,
      pincode: finalPincode,
      state: finalState,
      timestamp
    });
    QRData = newTestData.testQRData;
  } else {
    QRData = testQRData.testQRData;
  }
  return processQRDataSimple(QRData);
}
function processQRDataSimple(qrData) {
  const qrDataBytes = convertBigIntToByteArray2(BigInt(qrData));
  const decodedData = decompressByteArray2(qrDataBytes);
  const signedData = decodedData.slice(0, decodedData.length - 256);
  const [qrDataPaddedNumber, qrDataPaddedLen] = shaPad(signedData, 512 * 3);
  const qrDataPadded = new Uint8Array(qrDataPaddedNumber);
  let photoEOI = 0;
  for (let i = 0; i < qrDataPadded.length - 1; i++) {
    if (qrDataPadded[i + 1] === 217 && qrDataPadded[i] === 255) {
      photoEOI = i + 1;
    }
  }
  if (photoEOI === 0) {
    throw new Error("Photo EOI not found");
  }
  const extractedFields = extractQRDataFields(qrDataBytes);
  const qrDataWithoutTimestamp = [
    ...Array.from(qrDataPadded.slice(0, 9)),
    ...Array.from(qrDataPadded.slice(9, 26)).map((x) => 0),
    ...Array.from(qrDataPadded.slice(26))
  ];
  const qrHash = packBytesAndPoseidon(qrDataWithoutTimestamp);
  const photo = extractPhoto2(Array.from(qrDataPadded), photoEOI + 1);
  const photoHash = packBytesAndPoseidon(photo.bytes.map(Number));
  return {
    qrDataBytes,
    decodedData,
    signedData,
    qrDataPadded,
    qrDataPaddedLen,
    extractedFields,
    qrHash: BigInt(qrHash),
    photo,
    photoHash: BigInt(photoHash)
  };
}
var init_mockData = __esm({
  "src/utils/aadhaar/mockData.ts"() {
    init_constants();
    init_formatInputs();
    init_generateInputs();
    init_hash();
    init_shaPad();
    init_trees();
    init_dataInput();
    init_constants2();
    init_utils();
  }
});

// src/utils/csca.ts
function findStartIndex(modulus, messagePaddedNumber) {
  const modulusNumArray = [];
  for (let i = 0; i < modulus.length; i += 2) {
    const hexPair = modulus.slice(i, i + 2);
    const number = parseInt(hexPair, 16);
    modulusNumArray.push(number);
  }
  for (let i = 0; i < messagePaddedNumber.length - modulusNumArray.length + 1; i++) {
    let matched = true;
    for (let j = 0; j < modulusNumArray.length; j++) {
      if (modulusNumArray[j] !== messagePaddedNumber[i + j]) {
        matched = false;
        break;
      }
    }
    if (matched) {
      return [i, modulusNumArray.length];
    }
  }
  throw new Error("DSC Pubkey not found in certificate");
}
function findStartIndexEC(point, messagePadded) {
  const pointNumArray = [];
  for (let i = 0; i < point.length; i += 2) {
    pointNumArray.push(parseInt(point.slice(i, i + 2), 16));
  }
  let startIndex = -1;
  for (let i = 0; i < messagePadded.length - pointNumArray.length + 1; i++) {
    const isMatch = pointNumArray.every((byte, j) => messagePadded[i + j] === byte);
    if (isMatch) {
      startIndex = i;
      break;
    }
  }
  if (startIndex === -1) {
    throw new Error("DSC Pubkey not found in CSCA certificate");
  }
  return [startIndex, pointNumArray.length];
}
var init_csca = __esm({
  "src/utils/csca.ts"() {
  }
});

// src/utils/kyc/constants.ts
function createKycSelector(fieldsToReveal) {
  const bits = Array(KYC_MAX_LENGTH).fill(0);
  for (const field of fieldsToReveal) {
    const selectorBits = KYC_SELECTOR_BITS[field];
    for (const bit of selectorBits) {
      bits[bit] = 1;
    }
  }
  let lowResult = 0n;
  let highResult = 0n;
  const splitPoint = Math.floor(KYC_MAX_LENGTH / 2);
  for (let i = 0; i < splitPoint; i++) {
    if (bits[i]) {
      lowResult += 1n << BigInt(i);
    }
  }
  for (let i = splitPoint; i < KYC_MAX_LENGTH; i++) {
    if (bits[i]) {
      highResult += 1n << BigInt(i - splitPoint);
    }
  }
  return [lowResult, highResult];
}
var KYC_COUNTRY_INDEX, KYC_COUNTRY_LENGTH, KYC_ID_TYPE_INDEX, KYC_ID_TYPE_LENGTH, KYC_ID_NUMBER_INDEX, KYC_ID_NUMBER_LENGTH, KYC_ISSUANCE_DATE_INDEX, KYC_ISSUANCE_DATE_LENGTH, KYC_EXPIRY_DATE_INDEX, KYC_EXPIRY_DATE_LENGTH, KYC_FULL_NAME_INDEX, KYC_FULL_NAME_LENGTH, KYC_DOB_INDEX, KYC_DOB_LENGTH, KYC_PHOTO_HASH_INDEX, KYC_PHOTO_HASH_LENGTH, KYC_PHONE_NUMBER_INDEX, KYC_PHONE_NUMBER_LENGTH, KYC_GENDER_INDEX, KYC_GENDER_LENGTH, KYC_ADDRESS_INDEX, KYC_ADDRESS_LENGTH, KYC_MAX_LENGTH, KYC_REVEAL_DATA_INDICES, KYC_SELECTOR_BITS;
var init_constants3 = __esm({
  "src/utils/kyc/constants.ts"() {
    KYC_COUNTRY_INDEX = 0;
    KYC_COUNTRY_LENGTH = 3;
    KYC_ID_TYPE_INDEX = KYC_COUNTRY_INDEX + KYC_COUNTRY_LENGTH;
    KYC_ID_TYPE_LENGTH = 27;
    KYC_ID_NUMBER_INDEX = KYC_ID_TYPE_INDEX + KYC_ID_TYPE_LENGTH;
    KYC_ID_NUMBER_LENGTH = 32;
    KYC_ISSUANCE_DATE_INDEX = KYC_ID_NUMBER_INDEX + KYC_ID_NUMBER_LENGTH;
    KYC_ISSUANCE_DATE_LENGTH = 8;
    KYC_EXPIRY_DATE_INDEX = KYC_ISSUANCE_DATE_INDEX + KYC_ISSUANCE_DATE_LENGTH;
    KYC_EXPIRY_DATE_LENGTH = 8;
    KYC_FULL_NAME_INDEX = KYC_EXPIRY_DATE_INDEX + KYC_EXPIRY_DATE_LENGTH;
    KYC_FULL_NAME_LENGTH = 64;
    KYC_DOB_INDEX = KYC_FULL_NAME_INDEX + KYC_FULL_NAME_LENGTH;
    KYC_DOB_LENGTH = 8;
    KYC_PHOTO_HASH_INDEX = KYC_DOB_INDEX + KYC_DOB_LENGTH;
    KYC_PHOTO_HASH_LENGTH = 32;
    KYC_PHONE_NUMBER_INDEX = KYC_PHOTO_HASH_INDEX + KYC_PHOTO_HASH_LENGTH;
    KYC_PHONE_NUMBER_LENGTH = 12;
    KYC_GENDER_INDEX = KYC_PHONE_NUMBER_INDEX + KYC_PHONE_NUMBER_LENGTH;
    KYC_GENDER_LENGTH = 1;
    KYC_ADDRESS_INDEX = KYC_GENDER_INDEX + KYC_GENDER_LENGTH;
    KYC_ADDRESS_LENGTH = 100;
    KYC_MAX_LENGTH = KYC_ADDRESS_INDEX + KYC_ADDRESS_LENGTH;
    KYC_REVEAL_DATA_INDICES = {
      COUNTRY: 0,
      ID_TYPE: KYC_COUNTRY_LENGTH,
      ID_NUMBER: KYC_ID_TYPE_INDEX + KYC_ID_TYPE_LENGTH,
      ISSUANCE_DATE: KYC_ID_NUMBER_INDEX + KYC_ID_NUMBER_LENGTH,
      EXPIRY_DATE: KYC_ISSUANCE_DATE_INDEX + KYC_ISSUANCE_DATE_LENGTH,
      FULL_NAME: KYC_EXPIRY_DATE_INDEX + KYC_EXPIRY_DATE_LENGTH,
      DOB: KYC_FULL_NAME_INDEX + KYC_FULL_NAME_LENGTH,
      PHOTO_HASH: KYC_DOB_INDEX + KYC_DOB_LENGTH,
      PHONE_NUMBER: KYC_PHOTO_HASH_INDEX + KYC_PHOTO_HASH_LENGTH,
      GENDER: KYC_PHONE_NUMBER_INDEX + KYC_PHONE_NUMBER_LENGTH,
      ADDRESS: KYC_GENDER_INDEX + KYC_GENDER_LENGTH
    };
    KYC_SELECTOR_BITS = {
      COUNTRY: Array.from({ length: KYC_COUNTRY_LENGTH }, (_, i) => i),
      ID_TYPE: Array.from({ length: KYC_ID_TYPE_LENGTH }, (_, i) => i + KYC_COUNTRY_LENGTH),
      ID_NUMBER: Array.from(
        { length: KYC_ID_NUMBER_LENGTH },
        (_, i) => i + KYC_ID_TYPE_INDEX + KYC_ID_TYPE_LENGTH
      ),
      ISSUANCE_DATE: Array.from(
        { length: KYC_ISSUANCE_DATE_LENGTH },
        (_, i) => i + KYC_ID_NUMBER_INDEX + KYC_ID_NUMBER_LENGTH
      ),
      EXPIRY_DATE: Array.from(
        { length: KYC_EXPIRY_DATE_LENGTH },
        (_, i) => i + KYC_ISSUANCE_DATE_INDEX + KYC_ISSUANCE_DATE_LENGTH
      ),
      FULL_NAME: Array.from(
        { length: KYC_FULL_NAME_LENGTH },
        (_, i) => i + KYC_EXPIRY_DATE_INDEX + KYC_EXPIRY_DATE_LENGTH
      ),
      DOB: Array.from(
        { length: KYC_DOB_LENGTH },
        (_, i) => i + KYC_FULL_NAME_INDEX + KYC_FULL_NAME_LENGTH
      ),
      PHOTO_HASH: Array.from(
        { length: KYC_PHOTO_HASH_LENGTH },
        (_, i) => i + KYC_DOB_INDEX + KYC_DOB_LENGTH
      ),
      PHONE_NUMBER: Array.from(
        { length: KYC_PHONE_NUMBER_LENGTH },
        (_, i) => i + KYC_PHOTO_HASH_INDEX + KYC_PHOTO_HASH_LENGTH
      ),
      GENDER: Array.from(
        { length: KYC_GENDER_LENGTH },
        (_, i) => i + KYC_PHONE_NUMBER_INDEX + KYC_PHONE_NUMBER_LENGTH
      ),
      ADDRESS: Array.from(
        { length: KYC_ADDRESS_LENGTH },
        (_, i) => i + KYC_GENDER_INDEX + KYC_GENDER_LENGTH
      )
    };
  }
});

// src/utils/kyc/api.ts
function deserializeApplicantInfo(applicantInfoBase64) {
  const applicantInfo = Buffer.from(applicantInfoBase64, "base64").toString("utf-8");
  const country = applicantInfo.slice(KYC_COUNTRY_INDEX, KYC_COUNTRY_INDEX + KYC_COUNTRY_LENGTH).replace(/\x00/g, "");
  const idTypeRaw = applicantInfo.slice(KYC_ID_TYPE_INDEX, KYC_ID_TYPE_INDEX + KYC_ID_TYPE_LENGTH);
  const nsLen = idTypeRaw.charCodeAt(0);
  const idType = nsLen > 0 && nsLen < KYC_ID_TYPE_LENGTH ? idTypeRaw.slice(1 + nsLen).replace(/\x00/g, "") : idTypeRaw.replace(/\x00/g, "");
  const idNumber = applicantInfo.slice(KYC_ID_NUMBER_INDEX, KYC_ID_NUMBER_INDEX + KYC_ID_NUMBER_LENGTH).replace(/\x00/g, "");
  const issuanceDate = applicantInfo.slice(KYC_ISSUANCE_DATE_INDEX, KYC_ISSUANCE_DATE_INDEX + KYC_ISSUANCE_DATE_LENGTH).replace(/\x00/g, "");
  const expiryDate = applicantInfo.slice(KYC_EXPIRY_DATE_INDEX, KYC_EXPIRY_DATE_INDEX + KYC_EXPIRY_DATE_LENGTH).replace(/\x00/g, "");
  const fullName = applicantInfo.slice(KYC_FULL_NAME_INDEX, KYC_FULL_NAME_INDEX + KYC_FULL_NAME_LENGTH).replace(/\x00/g, "");
  const dob = applicantInfo.slice(KYC_DOB_INDEX, KYC_DOB_INDEX + KYC_DOB_LENGTH).replace(/\x00/g, "");
  const photoHash = applicantInfo.slice(KYC_PHOTO_HASH_INDEX, KYC_PHOTO_HASH_INDEX + KYC_PHOTO_HASH_LENGTH).replace(/\x00/g, "");
  const phoneNumber = applicantInfo.slice(KYC_PHONE_NUMBER_INDEX, KYC_PHONE_NUMBER_INDEX + KYC_PHONE_NUMBER_LENGTH).replace(/\x00/g, "");
  const gender = applicantInfo.slice(KYC_GENDER_INDEX, KYC_GENDER_INDEX + KYC_GENDER_LENGTH).replace(/\x00/g, "");
  const address = applicantInfo.slice(KYC_ADDRESS_INDEX, KYC_ADDRESS_INDEX + KYC_ADDRESS_LENGTH).replace(/\x00/g, "");
  return {
    country,
    idType,
    idNumber,
    issuanceDate,
    expiryDate,
    fullName,
    dob,
    photoHash,
    phoneNumber,
    gender,
    address
  };
}
function deserializeSignature(signature) {
  const [Rx, Ry, s] = Buffer.from(signature, "base64").toString("utf-8").split(",").map(BigInt);
  return { R: [Rx, Ry], s };
}
var init_api = __esm({
  "src/utils/kyc/api.ts"() {
    init_constants3();
  }
});

// src/utils/types.ts
function isKycDocument(passportData) {
  return passportData.documentCategory === "kyc";
}
var init_types = __esm({
  "src/utils/types.ts"() {
  }
});

// src/utils/passports/passport.ts
import { sha256 as sha2562 } from "js-sha256";
import forge4 from "node-forge";
import { poseidon5 as poseidon53 } from "poseidon-lite";
function extractRSFromSignature(signatureBytes) {
  const derSignature = Buffer.from(signatureBytes).toString("binary");
  const asn12 = forge4.asn1.fromDer(derSignature);
  const signatureAsn1 = asn12.value;
  if (signatureAsn1.length !== 2) {
    throw new Error("Invalid signature format");
  }
  if (!Array.isArray(asn12.value) || asn12.value.length !== 2) {
    throw new Error("Invalid signature format");
  }
  const r = forge4.util.createBuffer(asn12.value[0].value).toHex();
  const s = forge4.util.createBuffer(asn12.value[1].value).toHex();
  return { r, s };
}
function extractSignatureFromDSC(dscCertificate) {
  const cert = getCertificateFromPem(dscCertificate);
  const dscSignature = cert.signatureValue.valueBlock.valueHexView;
  return Array.from(dscSignature);
}
function findStartPubKeyIndex(certificateData, rawCert, signatureAlgorithm) {
  const { publicKeyDetails } = certificateData;
  if (signatureAlgorithm === "ecdsa") {
    const { x, y } = publicKeyDetails;
    const [x_index, x_totalLength] = findStartIndexEC(x, rawCert);
    const [y_index, y_totalLength] = findStartIndexEC(y, rawCert);
    return [x_index, x_totalLength + y_totalLength];
  } else {
    const { modulus } = publicKeyDetails;
    return findStartIndex(modulus, rawCert);
  }
}
function formatSignatureDSCCircuit(cscaSignatureAlgorithm, cscaHashFunction, cscaCertificateData, signature) {
  const cscaSignatureAlgorithmFullName = getSignatureAlgorithmFullName(
    cscaCertificateData,
    cscaSignatureAlgorithm,
    cscaHashFunction
  );
  const { n, k } = getNAndK(cscaSignatureAlgorithmFullName);
  if (cscaSignatureAlgorithm === "ecdsa") {
    const { r, s } = extractRSFromSignature(signature);
    const signature_r = splitToWords(BigInt(hexToDecimal(r)), n, k);
    const signature_s = splitToWords(BigInt(hexToDecimal(s)), n, k);
    return [...signature_r, ...signature_s];
  } else {
    return formatInput(splitToWords(BigInt(bytesToBigDecimal(signature)), n, k));
  }
}
function generateCommitment(secret, attestation_id, passportData) {
  const passportMetadata = passportData.passportMetadata;
  const dg1_packed_hash = packBytesAndPoseidon(formatMrz(passportData.mrz));
  const eContent_shaBytes = hash(
    passportMetadata.eContentHashFunction,
    Array.from(passportData.eContent),
    "bytes"
  );
  const eContent_packed_hash = packBytesAndPoseidon(
    eContent_shaBytes.map((byte) => byte & 255)
  );
  const dsc_hash = getLeafDscTree(passportData.dsc_parsed, passportData.csca_parsed);
  return poseidon53([
    secret,
    attestation_id,
    dg1_packed_hash,
    eContent_packed_hash,
    dsc_hash
  ]).toString();
}
function getPassportSignature(passportData, n, k) {
  const { signatureAlgorithm } = passportData.dsc_parsed;
  if (signatureAlgorithm === "ecdsa") {
    const { r, s } = extractRSFromSignature(passportData.encryptedDigest);
    const signature_r = splitToWords(BigInt(hexToDecimal(r)), n, k);
    const signature_s = splitToWords(BigInt(hexToDecimal(s)), n, k);
    return [...signature_r, ...signature_s];
  } else {
    return splitToWords(BigInt(bytesToBigDecimal(passportData.encryptedDigest)), n, k);
  }
}
function getCertificatePubKey(certificateData, signatureAlgorithm, hashFunction) {
  const signatureAlgorithmFullName = getSignatureAlgorithmFullName(
    certificateData,
    signatureAlgorithm,
    hashFunction
  );
  const { n, k } = getNAndK(signatureAlgorithmFullName);
  const { publicKeyDetails } = certificateData;
  if (signatureAlgorithm === "ecdsa") {
    const { x, y } = publicKeyDetails;
    const x_dsc = splitToWords(BigInt(hexToDecimal(x)), n, k);
    const y_dsc = splitToWords(BigInt(hexToDecimal(y)), n, k);
    return [...x_dsc, ...y_dsc];
  } else {
    const { modulus } = publicKeyDetails;
    return splitToWords(BigInt(hexToDecimal(modulus)), n, k);
  }
}
function getNAndK(sigAlg) {
  if (sigAlg === "rsa_sha256_65537_3072") {
    return { n: n_dsc_3072, k: k_dsc };
  }
  if (sigAlg.startsWith("ecdsa_")) {
    if (sigAlg.endsWith("224")) {
      return { n: 32, k: 7 };
    } else if (sigAlg.endsWith("256")) {
      return { n: n_dsc_ecdsa, k: 4 };
    } else if (sigAlg.endsWith("384")) {
      return { n: n_dsc_ecdsa, k: 6 };
    } else if (sigAlg.endsWith("512")) {
      return { n: n_dsc_ecdsa, k: 8 };
    } else if (sigAlg.endsWith("521")) {
      return { n: 66, k: 8 };
    } else {
      throw new Error("invalid key size");
    }
  }
  if (sigAlg.startsWith("rsapss_")) {
    const keyLength = parseInt(sigAlg.split("_")[3]);
    if (keyLength === 3072) {
      return { n: n_dsc_3072, k: k_dsc_3072 };
    }
    if (keyLength === 4096) {
      return { n: n_dsc_4096, k: k_dsc_4096 };
    }
    return { n: n_dsc, k: k_dsc };
  }
  if (sigAlg === "rsa_sha256_65537_4096" || sigAlg === "rsa_sha512_65537_4096") {
    return { n: n_dsc_4096, k: k_dsc_4096 };
  }
  return { n: n_dsc, k: k_dsc };
}
function getPassportSignatureInfos(passportData) {
  const passportMetadata = passportData.passportMetadata;
  const signatureAlgorithmFullName = getSignatureAlgorithmFullName(
    passportData.dsc_parsed,
    passportMetadata.signatureAlgorithm,
    passportMetadata.signedAttrHashFunction
  );
  const { n, k } = getNAndK(signatureAlgorithmFullName);
  return {
    pubKey: getCertificatePubKey(
      passportData.dsc_parsed,
      passportMetadata.signatureAlgorithm,
      passportMetadata.signedAttrHashFunction
    ),
    signature: getPassportSignature(passportData, n, k),
    signatureAlgorithmFullName
  };
}
function getSignatureAlgorithmFullName(certificateData, signatureAlgorithm, hashAlgorithm) {
  const { publicKeyDetails } = certificateData;
  if (signatureAlgorithm === "ecdsa") {
    return `${signatureAlgorithm}_${hashAlgorithm}_${publicKeyDetails.curve}_${publicKeyDetails.bits}`;
  } else {
    const { exponent } = publicKeyDetails;
    return `${signatureAlgorithm}_${hashAlgorithm}_${exponent}_${publicKeyDetails.bits}`;
  }
}
function pad(hashFunction) {
  return hashFunction === "sha1" || hashFunction === "sha224" || hashFunction === "sha256" ? shaPad : sha384_512Pad;
}
function padWithZeroes(bytes, length) {
  return bytes.concat(new Array(length - bytes.length).fill(0));
}
var init_passport = __esm({
  "src/utils/passports/passport.ts"() {
    init_constants();
    init_bytes();
    init_parseCertificateSimple();
    init_generateInputs();
    init_csca();
    init_hash();
    init_shaPad();
    init_trees();
    init_format();
  }
});

// src/utils/trees.ts
import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";
import {
  poseidon2 as poseidon23,
  poseidon3 as poseidon32,
  poseidon4 as poseidon42,
  poseidon5 as poseidon54,
  poseidon6 as poseidon62,
  poseidon8 as poseidon82,
  poseidon10 as poseidon102,
  poseidon12 as poseidon122,
  poseidon13 as poseidon132
} from "poseidon-lite";
import { IMT } from "@openpassport/zk-kit-imt";
import { LeanIMT } from "@openpassport/zk-kit-lean-imt";
import { SMT } from "@openpassport/zk-kit-smt";
function generateMerkleProof(imt, _index, maxleaf_depth) {
  const { siblings, index } = imt.generateProof(_index);
  const leaf_depth = siblings.length;
  const path = [];
  for (let i = 0; i < maxleaf_depth; i += 1) {
    path.push(index >> i & 1);
    if (siblings[i] === void 0) {
      siblings[i] = BigInt(0);
    }
  }
  return { siblings, path, leaf_depth };
}
function generateSMTProof(smt, leaf) {
  const { entry, matchingEntry, siblings, root, membership } = smt.createProof(leaf);
  const leaf_depth = siblings.length;
  let closestleaf;
  if (!matchingEntry) {
    if (!entry[1]) {
      closestleaf = BigInt(0);
    } else {
      closestleaf = BigInt(entry[0]);
    }
  } else {
    closestleaf = BigInt(matchingEntry[0]);
  }
  siblings.reverse();
  while (siblings.length < OFAC_TREE_LEVELS) siblings.push(BigInt(0));
  return {
    root,
    leaf_depth,
    closestleaf,
    siblings
  };
}
function getCscaTreeInclusionProof(leaf, _serialized_csca_tree) {
  const tree = new IMT(poseidon23, CSCA_TREE_DEPTH, 0, 2);
  tree.setNodes(_serialized_csca_tree);
  const index = tree.indexOf(leaf);
  if (index === -1) {
    throw new Error("Your public key was not found in the registry");
  }
  const proof = tree.createProof(index);
  return [
    tree.root,
    proof.pathIndices.map((index2) => index2.toString()),
    proof.siblings.flat().map((sibling) => sibling.toString())
  ];
}
function getDobLeaf(dobMrz, i) {
  if (dobMrz.length !== 6) {
    return BigInt(0);
  }
  try {
    return poseidon62(dobMrz);
  } catch (err) {
    console.error("Error in getDobLeaf:", err, "Index:", i, "DOB MRZ:", dobMrz);
    return BigInt(0);
  }
}
function getDscTreeInclusionProof(leaf, serialized_dsc_tree) {
  const hashFunction = (a, b) => poseidon23([a, b]);
  const tree = LeanIMT.import(hashFunction, serialized_dsc_tree);
  const index = tree.indexOf(BigInt(leaf));
  if (index === -1) {
    throw new Error("Your public key was not found in the registry");
  }
  const { siblings, path, leaf_depth } = generateMerkleProof(tree, index, DSC_TREE_DEPTH);
  return [tree.root, path, siblings, leaf_depth];
}
function getLeaf(parsed, type) {
  if (type === "dsc") {
    const tbsArray = Object.keys(parsed.tbsBytes).map((key) => parsed.tbsBytes[key]);
    const [paddedTbsBytes, tbsBytesPaddedLength] = pad(parsed.hashAlgorithm)(
      tbsArray,
      max_dsc_bytes
    );
    const dsc_hash = packBytesAndPoseidon(Array.from(paddedTbsBytes));
    return poseidon23([dsc_hash, tbsArray.length]).toString();
  } else {
    const tbsBytesArray = Array.from(parsed.tbsBytes);
    const paddedTbsBytesArray = tbsBytesArray.concat(
      new Array(max_csca_bytes - tbsBytesArray.length).fill(0)
    );
    const csca_hash = packBytesAndPoseidon(paddedTbsBytesArray);
    return poseidon23([csca_hash, tbsBytesArray.length]).toString();
  }
}
function generateSmallKey(input) {
  return input % (BigInt(1) << BigInt(OFAC_TREE_LEVELS));
}
function getYearLeaf(yearArr) {
  if (yearArr.length !== 2) {
    return BigInt(0);
  }
  try {
    return poseidon23(yearArr);
  } catch (err) {
    return BigInt(0);
  }
}
function getLeafCscaTree(csca_parsed) {
  return getLeaf(csca_parsed, "csca");
}
function getLeafDscTree(dsc_parsed, csca_parsed) {
  const dscLeaf = getLeaf(dsc_parsed, "dsc");
  const cscaLeaf = getLeaf(csca_parsed, "csca");
  return poseidon23([dscLeaf, cscaLeaf]).toString();
}
function getNameDobLeaf(nameMrz, dobMrz, i) {
  return generateSmallKey(poseidon23([getDobLeaf(dobMrz), getNameLeaf(nameMrz)]));
}
function getNameLeaf(nameMrz, i) {
  const middleChunks = [];
  const chunks = [];
  try {
    if (nameMrz.length == 39) {
      chunks.push(nameMrz.slice(0, 13), nameMrz.slice(13, 26), nameMrz.slice(26, 39));
      for (const chunk of chunks) {
        if (chunk.length !== 13)
          throw new Error(`Invalid chunk length for Poseidon13: ${chunk.length}`);
        middleChunks.push(poseidon132(chunk));
      }
    } else if (nameMrz.length == 30) {
      chunks.push(nameMrz.slice(0, 10), nameMrz.slice(10, 20), nameMrz.slice(20, 30));
      for (const chunk of chunks) {
        if (chunk.length !== 10)
          throw new Error(`Invalid chunk length for Poseidon10: ${chunk.length}`);
        middleChunks.push(poseidon102(chunk));
      }
    } else {
      throw new Error(`Unsupported name MRZ length: ${nameMrz.length}`);
    }
    if (middleChunks.length !== 3)
      throw new Error(`Invalid number of middle chunks: ${middleChunks.length}`);
    return poseidon32(middleChunks);
  } catch (err) {
    console.error("Error in getNameLeaf:", err, "Index:", i, "MRZ Length:", nameMrz.length);
    return BigInt(0);
  }
}
function getNameYobLeaf(nameMrz, yobMrz, i) {
  return generateSmallKey(poseidon23([getYearLeaf(yobMrz), getNameLeaf(nameMrz)]));
}
function getPassportNumberAndNationalityLeaf(passport, nationality, i) {
  if (passport.length !== 9) {
    console.log("parsed passport length is not 9:", i, passport);
    return;
  }
  if (nationality.length !== 3) {
    console.log("parsed nationality length is not 3:", i, nationality);
    return;
  }
  try {
    const fullHash = poseidon122(passport.concat(nationality));
    return generateSmallKey(fullHash);
  } catch (err) {
    console.log("err : passport", err, i, passport);
  }
}
var getNameDobLeafAadhaar, getNameDobLeafKyc, getNameYobLeafAahaar, getNameYobLeafKyc, processYearKyc;
var init_trees = __esm({
  "src/utils/trees.ts"() {
    init_constants();
    init_bytes();
    init_uuid();
    init_hash();
    init_passport();
    countries.registerLocale(en);
    getNameDobLeafAadhaar = (name, year, month, day) => {
      const paddedName = name.toUpperCase().padEnd(62, "\0").split("").map((char) => char.charCodeAt(0));
      const namePacked = packBytes(paddedName);
      return generateSmallKey(
        poseidon54([namePacked[0], namePacked[1], BigInt(year), BigInt(month), BigInt(day)])
      );
    };
    getNameDobLeafKyc = (name, dob) => {
      const namePaddingLength = 64;
      const paddedName = name.padEnd(namePaddingLength, "\0").split("").map((char) => char.charCodeAt(0));
      const nameHash = BigInt(packBytesAndPoseidon(paddedName));
      const dobHash = BigInt(poseidon82(stringToAsciiBigIntArray(dob)));
      return generateSmallKey(poseidon23([dobHash, nameHash]));
    };
    getNameYobLeafAahaar = (name, year) => {
      const paddedName = name.toUpperCase().padEnd(62, "\0").split("").map((char) => char.charCodeAt(0));
      const namePacked = packBytes(paddedName);
      return generateSmallKey(poseidon32([namePacked[0], namePacked[1], BigInt(year)]));
    };
    getNameYobLeafKyc = (name, yob) => {
      const namePaddingLength = 64;
      const paddedName = name.padEnd(namePaddingLength, "\0").split("").map((char) => char.charCodeAt(0));
      const nameHash = BigInt(packBytesAndPoseidon(paddedName));
      const yearHash = processYearKyc(yob, 0);
      return generateSmallKey(poseidon23([yearHash, nameHash]));
    };
    processYearKyc = (year, i) => {
      const yearArr = stringToAsciiBigIntArray(year);
      return BigInt(poseidon42(yearArr));
    };
  }
});

// src/utils/circuits/registerInputs.ts
init_constants();
import { poseidon2 as poseidon25 } from "poseidon-lite";

// src/utils/scope.ts
init_hash();
import { poseidon2 as poseidon22 } from "poseidon-lite";
function formatEndpoint(endpoint) {
  if (!endpoint) return "";
  const formatted = endpoint.replace(/^https?:\/\//, "").split("/")[0];
  if (formatted.startsWith("0x")) {
    return formatted.toLowerCase();
  }
  return formatted;
}
function hashEndpointWithScope(endpoint, scope) {
  const formattedEndpoint = formatEndpoint(endpoint);
  const endpointChunks = [];
  let remaining = formattedEndpoint;
  while (remaining.length > 0) {
    const chunk = remaining.slice(0, 31);
    endpointChunks.push(chunk);
    remaining = remaining.slice(31);
  }
  if (endpointChunks.length > 16) {
    throw new Error("Endpoint must be less than 496 characters");
  }
  const chunkedEndpointBigInts = endpointChunks.map(stringToBigInt);
  const endpointHash = flexiblePoseidon(chunkedEndpointBigInts);
  const scopeBigInt = stringToBigInt(scope);
  return poseidon22([endpointHash, scopeBigInt]).toString();
}
function stringToBigInt(str) {
  if (!/^[\x00-\x7F]*$/.test(str)) {
    throw new Error("Input must contain only ASCII characters (0-127)");
  }
  let result = 0n;
  for (let i = 0; i < str.length; i++) {
    result = result << 8n | BigInt(str.charCodeAt(i));
  }
  const MAX_VALUE = (1n << 248n) - 1n;
  if (result > MAX_VALUE) {
    console.log(`str: ${str}, str.length: ${str.length}`);
    throw new Error("Resulting BigInt exceeds maximum size of 31 bytes");
  }
  return result;
}

// src/utils/index.ts
init_hash();

// src/constants/countries.ts
var countries2 = {
  AFGHANISTAN: "AFG",
  ALAND_ISLANDS: "ALA",
  ALBANIA: "ALB",
  ALGERIA: "DZA",
  AMERICAN_SAMOA: "ASM",
  ANDORRA: "AND",
  ANGOLA: "AGO",
  ANGUILLA: "AIA",
  ANTARCTICA: "ATA",
  ANTIGUA_AND_BARBUDA: "ATG",
  ARGENTINA: "ARG",
  ARMENIA: "ARM",
  ARUBA: "ABW",
  AUSTRALIA: "AUS",
  AUSTRIA: "AUT",
  AZERBAIJAN: "AZE",
  BAHAMAS: "BHS",
  BAHRAIN: "BHR",
  BANGLADESH: "BGD",
  BARBADOS: "BRB",
  BELARUS: "BLR",
  BELGIUM: "BEL",
  BELIZE: "BLZ",
  BENIN: "BEN",
  BERMUDA: "BMU",
  BHUTAN: "BTN",
  BOLIVIA: "BOL",
  BONAIRE_SINT_EUSTATIUS_AND_SABA: "BES",
  BOSNIA_AND_HERZEGOVINA: "BIH",
  BOTSWANA: "BWA",
  BOUVET_ISLAND: "BVT",
  BRAZIL: "BRA",
  BRITISH_INDIAN_OCEAN_TERRITORY: "IOT",
  BRUNEI: "BRN",
  BULGARIA: "BGR",
  BURKINA_FASO: "BFA",
  BURUNDI: "BDI",
  CAPE_VERDE: "CPV",
  CAMBODIA: "KHM",
  CAMEROON: "CMR",
  CANADA: "CAN",
  CAYMAN_ISLANDS: "CYM",
  CENTRAL_AFRICAN_REPUBLIC: "CAF",
  CHAD: "TCD",
  CHILE: "CHL",
  CHINA: "CHN",
  CHRISTMAS_ISLAND: "CXR",
  COCOS_ISLANDS: "CCK",
  COLOMBIA: "COL",
  COMOROS: "COM",
  CONGO: "COG",
  DR_CONGO: "COD",
  COOK_ISLANDS: "COK",
  COSTA_RICA: "CRI",
  IVORY_COAST: "CIV",
  CROATIA: "HRV",
  CUBA: "CUB",
  CURACAO: "CUW",
  CYPRUS: "CYP",
  CZECH_REPUBLIC: "CZE",
  DENMARK: "DNK",
  DJIBOUTI: "DJI",
  DOMINICA: "DMA",
  DOMINICAN_REPUBLIC: "DOM",
  ECUADOR: "ECU",
  EGYPT: "EGY",
  EL_SALVADOR: "SLV",
  EQUATORIAL_GUINEA: "GNQ",
  ERITREA: "ERI",
  ESTONIA: "EST",
  ESWATINI: "SWZ",
  ETHIOPIA: "ETH",
  FALKLAND_ISLANDS: "FLK",
  FAROE_ISLANDS: "FRO",
  FIJI: "FJI",
  FINLAND: "FIN",
  FRANCE: "FRA",
  FRENCH_GUIANA: "GUF",
  FRENCH_POLYNESIA: "PYF",
  FRENCH_SOUTHERN_TERRITORIES: "ATF",
  GABON: "GAB",
  GAMBIA: "GMB",
  GEORGIA: "GEO",
  GERMANY: "D<<",
  GHANA: "GHA",
  GIBRALTAR: "GIB",
  GREECE: "GRC",
  GREENLAND: "GRL",
  GRENADA: "GRD",
  GUADELOUPE: "GLP",
  GUAM: "GUM",
  GUATEMALA: "GTM",
  GUERNSEY: "GGY",
  GUINEA: "GIN",
  GUINEA_BISSAU: "GNB",
  GUYANA: "GUY",
  HAITI: "HTI",
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: "HMD",
  VATICAN_CITY: "VAT",
  HONDURAS: "HND",
  HONG_KONG: "HKG",
  HUNGARY: "HUN",
  ICELAND: "ISL",
  INDIA: "IND",
  INDONESIA: "IDN",
  IRAN: "IRN",
  IRAQ: "IRQ",
  IRELAND: "IRL",
  ISLE_OF_MAN: "IMN",
  ISRAEL: "ISR",
  ITALY: "ITA",
  JAMAICA: "JAM",
  JAPAN: "JPN",
  JERSEY: "JEY",
  JORDAN: "JOR",
  KAZAKHSTAN: "KAZ",
  KENYA: "KEN",
  KIRIBATI: "KIR",
  NORTH_KOREA: "PRK",
  SOUTH_KOREA: "KOR",
  KUWAIT: "KWT",
  KYRGYZSTAN: "KGZ",
  LAOS: "LAO",
  LATVIA: "LVA",
  LEBANON: "LBN",
  LESOTHO: "LSO",
  LIBERIA: "LBR",
  LIBYA: "LBY",
  LIECHTENSTEIN: "LIE",
  LITHUANIA: "LTU",
  LUXEMBOURG: "LUX",
  MACAO: "MAC",
  MADAGASCAR: "MDG",
  MALAWI: "MWI",
  MALAYSIA: "MYS",
  MALDIVES: "MDV",
  MALI: "MLI",
  MALTA: "MLT",
  MARSHALL_ISLANDS: "MHL",
  MARTINIQUE: "MTQ",
  MAURITANIA: "MRT",
  MAURITIUS: "MUS",
  MAYOTTE: "MYT",
  MEXICO: "MEX",
  MICRONESIA: "FSM",
  MOLDOVA: "MDA",
  MONACO: "MCO",
  MONGOLIA: "MNG",
  MONTENEGRO: "MNE",
  MONTSERRAT: "MSR",
  MOROCCO: "MAR",
  MOZAMBIQUE: "MOZ",
  MYANMAR: "MMR",
  NAMIBIA: "NAM",
  NAURU: "NRU",
  NEPAL: "NPL",
  NETHERLANDS: "NLD",
  NEW_CALEDONIA: "NCL",
  NEW_ZEALAND: "NZL",
  NICARAGUA: "NIC",
  NIGER: "NER",
  NIGERIA: "NGA",
  NIUE: "NIU",
  NORFOLK_ISLAND: "NFK",
  NORTH_MACEDONIA: "MKD",
  NORTHERN_MARIANA_ISLANDS: "MNP",
  NORWAY: "NOR",
  OMAN: "OMN",
  PAKISTAN: "PAK",
  PALAU: "PLW",
  PALESTINE: "PSE",
  PANAMA: "PAN",
  PAPUA_NEW_GUINEA: "PNG",
  PARAGUAY: "PRY",
  PERU: "PER",
  PHILIPPINES: "PHL",
  PITCAIRN: "PCN",
  POLAND: "POL",
  PORTUGAL: "PRT",
  PUERTO_RICO: "PRI",
  QATAR: "QAT",
  REUNION: "REU",
  ROMANIA: "ROU",
  RUSSIA: "RUS",
  RWANDA: "RWA",
  SAINT_BARTHELEMY: "BLM",
  SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA: "SHN",
  SAINT_KITTS_AND_NEVIS: "KNA",
  SAINT_LUCIA: "LCA",
  SAINT_MARTIN: "MAF",
  SAINT_PIERRE_AND_MIQUELON: "SPM",
  SAINT_VINCENT_AND_THE_GRENADINES: "VCT",
  SAMOA: "WSM",
  SAN_MARINO: "SMR",
  SAO_TOME_AND_PRINCIPE: "STP",
  SAUDI_ARABIA: "SAU",
  SENEGAL: "SEN",
  SERBIA: "SRB",
  SEYCHELLES: "SYC",
  SIERRA_LEONE: "SLE",
  SINGAPORE: "SGP",
  SINT_MAARTEN: "SXM",
  SLOVAKIA: "SVK",
  SLOVENIA: "SVN",
  SOLOMON_ISLANDS: "SLB",
  SOMALIA: "SOM",
  SOUTH_AFRICA: "ZAF",
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: "SGS",
  SOUTH_SUDAN: "SSD",
  SPAIN: "ESP",
  SRI_LANKA: "LKA",
  SUDAN: "SDN",
  SURINAME: "SUR",
  SVALBARD_AND_JAN_MAYEN: "SJM",
  SWEDEN: "SWE",
  SWITZERLAND: "CHE",
  SYRIAN_ARAB_REPUBLIC: "SYR",
  TAIWAN: "TWN",
  TAJIKISTAN: "TJK",
  TANZANIA: "TZA",
  THAILAND: "THA",
  TIMOR_LESTE: "TLS",
  TOGO: "TGO",
  TOKELAU: "TKL",
  TONGA: "TON",
  TRINIDAD_AND_TOBAGO: "TTO",
  TUNISIA: "TUN",
  TURKEY: "TUR",
  TURKMENISTAN: "TKM",
  TURKS_AND_CAICOS_ISLANDS: "TCA",
  TUVALU: "TUV",
  UGANDA: "UGA",
  UKRAINE: "UKR",
  UNITED_ARAB_EMIRATES: "ARE",
  UNITED_KINGDOM: "GBR",
  UNITED_STATES: "USA",
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: "UMI",
  URUGUAY: "URY",
  UZBEKISTAN: "UZB",
  VANUATU: "VUT",
  VENEZUELA: "VEN",
  VIET_NAM: "VNM",
  VIRGIN_ISLANDS_BRITISH: "VGB",
  VIRGIN_ISLANDS_US: "VIR",
  WALLIS_AND_FUTUNA: "WLF",
  WESTERN_SAHARA: "ESH",
  YEMEN: "YEM",
  ZAMBIA: "ZMB",
  ZIMBABWE: "ZWE",
  EUROPEAN_UNION: "EUE",
  UNITED_NATIONS: "UNO",
  COUNCIL_OF_EUROPE: "XCE",
  INTERPOL: "XPO",
  SMOM: "XOM"
};
var ALPHA2_TO_ALPHA3 = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BA: "BIH",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BQ: "BES",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CW: "CUW",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SX: "SXM",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
var ALPHA3_TO_ALPHA2 = Object.fromEntries(
  Object.entries(ALPHA2_TO_ALPHA3).map(([k, v]) => [v, k])
);

// src/utils/passports/genMockIdDoc.ts
import * as asn1 from "asn1js";
import elliptic from "elliptic";
import forge5 from "node-forge";
var defaultIdDocInput = {
  idType: "mock_passport",
  dgHashAlgo: "sha256",
  eContentHashAlgo: "sha256",
  signatureType: "rsa_sha256_65537_2048",
  nationality: countries2.UNITED_STATES,
  birthDate: "900101",
  expiryDate: "300101",
  passportNumber: "123456789",
  lastName: void 0,
  firstName: void 0,
  sex: "M",
  // Aadhaar defaults
  pincode: "110051",
  state: "Delhi"
};

// src/utils/index.ts
init_generateInputs();

// src/utils/circuits/circuitsName.ts
init_types();
function getCircuitNameFromPassportData(passportData, circuitType) {
  if (circuitType === "register") {
    return getRegisterNameFromPassportData(passportData);
  } else {
    return getDSCircuitNameFromPassportData(passportData);
  }
}
function getDSCircuitNameFromPassportData(passportData) {
  console.log("Getting DSC circuit name from passport data...");
  if (isKycDocument(passportData)) {
    throw new Error("KYC documents do not have a DSC circuit");
  }
  if (passportData.documentCategory === "aadhaar") {
    throw new Error("Aadhaar does not have a DSC circuit");
  }
  if (!passportData.passportMetadata) {
    console.error("Passport metadata is missing");
    throw new Error("Passport data are not parsed");
  }
  const passportMetadata = passportData.passportMetadata;
  if (!passportMetadata.cscaFound) {
    console.error("CSCA not found in passport metadata");
    throw new Error("CSCA not found");
  }
  const signatureAlgorithm = passportMetadata.cscaSignatureAlgorithm;
  const hashFunction = passportMetadata.cscaHashFunction;
  console.log("CSCA Signature Algorithm:", signatureAlgorithm);
  console.log("CSCA Hash Function:", hashFunction);
  if (signatureAlgorithm === "ecdsa") {
    console.log("Processing ECDSA signature...");
    const curve = passportMetadata.cscaCurveOrExponent;
    console.log("ECDSA curve:", curve);
    const circuitName = `dsc_${hashFunction}_${signatureAlgorithm}_${curve}`;
    console.log("Generated circuit name:", circuitName);
    return circuitName;
  } else if (signatureAlgorithm === "rsa") {
    console.log("Processing RSA signature...");
    const exponent = passportMetadata.cscaCurveOrExponent;
    const bits = passportMetadata.cscaSignatureAlgorithmBits;
    console.log("RSA exponent:", exponent);
    console.log("RSA bits:", bits);
    if (bits <= 4096) {
      const circuitName = `dsc_${hashFunction}_${signatureAlgorithm}_${exponent}_${4096}`;
      console.log("Generated circuit name:", circuitName);
      return circuitName;
    } else {
      console.error("RSA key length exceeds maximum supported length");
      throw new Error(`Unsupported key length: ${bits}`);
    }
  } else if (signatureAlgorithm === "rsapss") {
    console.log("Processing RSA-PSS signature...");
    const exponent = passportMetadata.cscaCurveOrExponent;
    const saltLength = passportMetadata.cscaSaltLength;
    const bits = passportMetadata.cscaSignatureAlgorithmBits;
    console.log("RSA-PSS exponent:", exponent);
    console.log("RSA-PSS salt length:", saltLength);
    console.log("RSA-PSS bits:", bits);
    if (bits <= 4096) {
      const circuitName = `dsc_${hashFunction}_${signatureAlgorithm}_${exponent}_${saltLength}_${bits}`;
      console.log("Generated circuit name:", circuitName);
      return circuitName;
    } else {
      console.error("RSA-PSS key length exceeds maximum supported length");
      throw new Error(`Unsupported key length: ${bits}`);
    }
  } else {
    console.error("Unsupported signature algorithm:", signatureAlgorithm);
    throw new Error("Unsupported signature algorithm");
  }
}
function getRegisterNameFromPassportData(passportData) {
  console.log("Getting register circuit name from passport data...");
  if (passportData.documentCategory === "aadhaar") {
    return "register_aadhaar";
  }
  if (isKycDocument(passportData)) {
    return "register_kyc";
  }
  if (!passportData.passportMetadata) {
    console.error("Passport metadata is missing");
    throw new Error("Passport data are not parsed");
  }
  const passportMetadata = passportData.passportMetadata;
  if (!passportMetadata.cscaFound) {
    console.error("CSCA not found in passport metadata");
    throw new Error("CSCA not found");
  }
  const dgHashAlgo = passportMetadata.dg1HashFunction;
  const eContentHashAlgo = passportMetadata.eContentHashFunction;
  const signedAttrHashAlgo = passportMetadata.signedAttrHashFunction;
  const sigAlg = passportMetadata.signatureAlgorithm;
  console.log("DG Hash Algorithm:", dgHashAlgo);
  console.log("eContent Hash Algorithm:", eContentHashAlgo);
  console.log("Signed Attributes Hash Algorithm:", signedAttrHashAlgo);
  console.log("Signature Algorithm:", sigAlg);
  const prefix = passportData.documentType === "id_card" || passportData.documentType === "mock_id_card" ? "register_id" : "register";
  if (sigAlg === "ecdsa") {
    console.log("Processing ECDSA signature...");
    const { curveOrExponent } = passportMetadata;
    console.log("ECDSA curve:", curveOrExponent);
    const circuitName = `${prefix}_${dgHashAlgo}_${eContentHashAlgo}_${signedAttrHashAlgo}_${sigAlg}_${curveOrExponent}`;
    console.log("Generated circuit name:", circuitName);
    return circuitName;
  } else if (sigAlg === "rsa") {
    console.log("Processing RSA signature...");
    const { curveOrExponent, signatureAlgorithmBits } = passportMetadata;
    console.log("RSA exponent:", curveOrExponent);
    console.log("RSA bits:", signatureAlgorithmBits);
    if (signatureAlgorithmBits <= 4096) {
      const circuitName = `${prefix}_${dgHashAlgo}_${eContentHashAlgo}_${signedAttrHashAlgo}_${sigAlg}_${curveOrExponent}_${4096}`;
      console.log("Generated circuit name:", circuitName);
      return circuitName;
    } else {
      console.error("RSA key length exceeds maximum supported length");
      throw new Error(`Unsupported key length: ${signatureAlgorithmBits}`);
    }
  } else if (sigAlg === "rsapss") {
    console.log("Processing RSA-PSS signature...");
    const { curveOrExponent, saltLength, signatureAlgorithmBits } = passportMetadata;
    console.log("RSA-PSS exponent:", curveOrExponent);
    console.log("RSA-PSS salt length:", saltLength);
    console.log("RSA-PSS bits:", signatureAlgorithmBits);
    if (signatureAlgorithmBits <= 4096) {
      const circuitName = `${prefix}_${dgHashAlgo}_${eContentHashAlgo}_${signedAttrHashAlgo}_${sigAlg}_${curveOrExponent}_${saltLength}_${signatureAlgorithmBits}`;
      console.log("Generated circuit name:", circuitName);
      return circuitName;
    } else {
      console.error("RSA-PSS key length exceeds maximum supported length");
      throw new Error(`Unsupported key length: ${signatureAlgorithmBits}`);
    }
  } else {
    console.error("Unsupported signature algorithm:", sigAlg);
    throw new Error("Unsupported signature algorithm");
  }
}

// src/utils/index.ts
init_csca();

// src/utils/kyc/generateInputs.ts
init_constants();
init_formatInputs();
init_generateInputs();
init_hash();
init_trees();
init_api();
init_constants3();
import { poseidon2 as poseidon24 } from "poseidon-lite";
import { Base8, inCurve, mulPointEscalar, subOrder } from "@zk-kit/baby-jubjub";
var createKycDiscloseSelFromFields = (fieldsToReveal) => {
  const [lowResult, highResult] = createKycSelector(fieldsToReveal);
  return [lowResult.toString(), highResult.toString()];
};
var generateCircuitInputsOfac = (data, smt, proofLevel) => {
  const name = data.fullName;
  const dob = data.dob;
  const yob = data.dob.slice(0, 4);
  const nameDobLeaf = getNameDobLeafKyc(name, dob);
  const nameYobLeaf = getNameYobLeafKyc(name, yob);
  let root, closestleaf, siblings;
  if (proofLevel == 2) {
    ({ root, closestleaf, siblings } = generateSMTProof(smt, nameDobLeaf));
  } else if (proofLevel == 1) {
    ({ root, closestleaf, siblings } = generateSMTProof(smt, nameYobLeaf));
  } else {
    throw new Error("Invalid proof level");
  }
  return {
    smt_root: formatInput(root),
    smt_leaf_key: formatInput(closestleaf),
    smt_siblings: formatInput(siblings)
  };
};
var generateKycDiscloseInputFromData = (serializedApplicantInfo, secret, nameDobSmt, nameYobSmt, identityTree, ofac, scope, userIdentifier, fieldsToReveal, forbiddenCountriesList, minimumAge) => {
  const raw = Buffer.from(serializedApplicantInfo, "base64");
  const msgPadded = [
    ...Array.from(raw, (b) => Number(b)),
    ...new Array(Math.max(0, KYC_MAX_LENGTH - raw.length)).fill(0)
  ];
  const commitment = poseidon24([secret, packBytesAndPoseidon(msgPadded)]);
  const index = findIndexInTree(identityTree, commitment);
  const {
    siblings,
    path: merkle_path,
    leaf_depth
  } = generateMerkleProof(identityTree, index, COMMITMENT_TREE_DEPTH);
  const applicantData = deserializeApplicantInfo(serializedApplicantInfo);
  const ofacData = {
    ...applicantData,
    user_identifier: "",
    current_date: "",
    majority_age_ASCII: "",
    selector_older_than: ""
  };
  const nameDobInputs = generateCircuitInputsOfac(ofacData, nameDobSmt, 2);
  const nameYobInputs = generateCircuitInputsOfac(ofacData, nameYobSmt, 1);
  const fieldsToRevealFinal = fieldsToReveal || [];
  const compressed_disclose_sel = createKycDiscloseSelFromFields(fieldsToRevealFinal);
  const majorityAgeASCII = minimumAge ? minimumAge.toString().padStart(3, "0").split("").map((x) => x.charCodeAt(0)) : ["0", "0", "0"].map((x) => x.charCodeAt(0));
  const currentDate = (/* @__PURE__ */ new Date()).toISOString().split("T")[0].replace(/-/g, "").split("");
  const circuitInput = {
    data_padded: formatInput(msgPadded),
    compressed_disclose_sel,
    scope,
    merkle_root: formatInput(BigInt(identityTree.root)),
    leaf_depth: formatInput(leaf_depth),
    path: formatInput(merkle_path),
    siblings: formatInput(siblings),
    forbidden_countries_list: forbiddenCountriesList ? formatInput(formatCountriesList(forbiddenCountriesList)) : [...Array(120)].map(() => "0"),
    ofac_name_dob_smt_leaf_key: nameDobInputs.smt_leaf_key,
    ofac_name_dob_smt_root: nameDobInputs.smt_root,
    ofac_name_dob_smt_siblings: nameDobInputs.smt_siblings,
    ofac_name_yob_smt_leaf_key: nameYobInputs.smt_leaf_key,
    ofac_name_yob_smt_root: nameYobInputs.smt_root,
    ofac_name_yob_smt_siblings: nameYobInputs.smt_siblings,
    selector_ofac: ofac ? ["1"] : ["0"],
    user_identifier: userIdentifier,
    current_date: currentDate,
    majority_age_ASCII: majorityAgeASCII,
    secret
  };
  return circuitInput;
};
var generateKycRegisterInput = async (applicantInfoBase64, signatureBase64, pubkeyStr, secret) => {
  const signature = deserializeSignature(signatureBase64);
  const pubkey = [BigInt(pubkeyStr[0]), BigInt(pubkeyStr[1])];
  const raw = Buffer.from(applicantInfoBase64, "base64");
  const dataPadded = [
    ...Array.from(raw, (b) => Number(b)),
    ...new Array(Math.max(0, KYC_MAX_LENGTH - raw.length)).fill(0)
  ];
  const kycRegisterInput = {
    data_padded: dataPadded,
    s: signature.s,
    R: signature.R,
    pubKey: pubkey,
    secret
  };
  return kycRegisterInput;
};

// src/utils/circuits/registerInputs.ts
init_generateInputs();
import { LeanIMT as LeanIMT2 } from "@openpassport/zk-kit-lean-imt";
import { SMT as SMT2 } from "@openpassport/zk-kit-smt";
function generateTEEInputsAadhaarDisclose(secret, aadhaarData, selfApp, getTree) {
  const { prepareAadhaarDiscloseData: prepareAadhaarDiscloseData2 } = (init_mockData(), __toCommonJS(mockData_exports));
  const { scope, disclosures, endpoint, userId, userDefinedData, chainID } = selfApp;
  const userIdentifierHash = calculateUserIdentifierHash(chainID, userId, userDefinedData);
  const scope_hash = hashEndpointWithScope(endpoint, scope);
  const ofac_trees = getTree("aadhaar", "ofac");
  if (!ofac_trees) {
    throw new Error("OFAC trees not loaded");
  }
  if (!ofac_trees.nameAndDob || !ofac_trees.nameAndYob) {
    throw new Error("Invalid OFAC tree structure: missing required fields");
  }
  const nameAndDobSMT = new SMT2(poseidon25, true);
  const nameAndYobSMT = new SMT2(poseidon25, true);
  nameAndDobSMT.import(ofac_trees.nameAndDob);
  nameAndYobSMT.import(ofac_trees.nameAndYob);
  const serialized_tree = getTree("aadhaar", "commitment");
  const tree = LeanIMT2.import((a, b) => poseidon25([a, b]), serialized_tree);
  const inputs = prepareAadhaarDiscloseData2(
    aadhaarData.qrData,
    tree,
    nameAndDobSMT,
    nameAndYobSMT,
    scope_hash,
    secret,
    userIdentifierHash.toString(),
    {
      dateOfBirth: disclosures.date_of_birth,
      name: disclosures.name,
      gender: disclosures.gender,
      idNumber: disclosures.passport_number,
      issuingState: disclosures.issuing_state,
      minimumAge: disclosures.minimumAge,
      forbiddenCountriesListPacked: disclosures.excludedCountries,
      ofac: disclosures.ofac
    }
  );
  return {
    inputs,
    circuitName: "vc_and_disclose_aadhaar",
    endpointType: selfApp.endpointType,
    endpoint: selfApp.endpoint
  };
}
async function generateTEEInputsAadhaarRegister(secret, aadhaarData, publicKeys, env) {
  const { prepareAadhaarRegisterData: prepareAadhaarRegisterData2 } = (init_mockData(), __toCommonJS(mockData_exports));
  console.log(
    "publicKeys-aadhaar",
    publicKeys,
    "secret-aadhaar",
    secret,
    "aadhaarData-aadhaar",
    aadhaarData
  );
  const inputs = await prepareAadhaarRegisterData2(aadhaarData.qrData, secret, publicKeys);
  const circuitName = "register_aadhaar";
  const endpointType = env === "stg" ? "staging_celo" : "celo";
  const endpoint = "https://self.xyz";
  return { inputs, circuitName, endpointType, endpoint };
}
function generateTEEInputsDSC(passportData, cscaTree, env) {
  const inputs = generateCircuitInputsDSC(passportData, cscaTree);
  const circuitName = getCircuitNameFromPassportData(passportData, "dsc");
  const endpointType = env === "stg" ? "staging_celo" : "celo";
  const endpoint = "https://self.xyz";
  return { inputs, circuitName, endpointType, endpoint };
}
function generateTEEInputsDiscloseStateless(secret, passportData, selfApp, getTree) {
  if (passportData.documentCategory === "aadhaar") {
    const { inputs: inputs2, circuitName, endpointType, endpoint: endpoint2 } = generateTEEInputsAadhaarDisclose(
      secret,
      passportData,
      selfApp,
      getTree
    );
    return { inputs: inputs2, circuitName, endpointType, endpoint: endpoint2 };
  }
  if (passportData.documentCategory === "kyc") {
    const { inputs: inputs2, circuitName, endpointType, endpoint: endpoint2 } = generateTEEInputsKycDisclose(
      secret,
      passportData,
      selfApp,
      getTree
    );
    return { inputs: inputs2, circuitName, endpointType, endpoint: endpoint2 };
  }
  const { scope, disclosures, endpoint, userId, userDefinedData, chainID } = selfApp;
  const userIdentifierHash = calculateUserIdentifierHash(chainID, userId, userDefinedData);
  const scope_hash = hashEndpointWithScope(endpoint, scope);
  const document = passportData.documentCategory;
  const selector_dg1 = getSelectorDg1(document, disclosures);
  const majority = disclosures.minimumAge ? disclosures.minimumAge.toString() : DEFAULT_MAJORITY;
  const selector_older_than = disclosures.minimumAge ? "1" : "0";
  const selector_ofac = disclosures.ofac ? 1 : 0;
  const ofac_trees = getTree(document, "ofac");
  if (!ofac_trees) {
    throw new Error("OFAC trees not loaded");
  }
  if (!ofac_trees.nameAndDob || !ofac_trees.nameAndYob) {
    throw new Error("Invalid OFAC tree structure: missing required fields");
  }
  if (document === "passport" && !ofac_trees.passportNoAndNationality) {
    throw new Error("Invalid OFAC tree structure: missing passportNoAndNationality for passport");
  }
  let passportNoAndNationalitySMT = null;
  const nameAndDobSMT = new SMT2(poseidon25, true);
  const nameAndYobSMT = new SMT2(poseidon25, true);
  if (document === "passport") {
    passportNoAndNationalitySMT = new SMT2(poseidon25, true);
    passportNoAndNationalitySMT.import(ofac_trees.passportNoAndNationality);
  }
  nameAndDobSMT.import(ofac_trees.nameAndDob);
  nameAndYobSMT.import(ofac_trees.nameAndYob);
  const serialized_tree = getTree(document, "commitment");
  const tree = LeanIMT2.import((a, b) => poseidon25([a, b]), serialized_tree);
  const inputs = generateCircuitInputsVCandDisclose(
    secret,
    document === "passport" ? PASSPORT_ATTESTATION_ID : ID_CARD_ATTESTATION_ID,
    passportData,
    scope_hash,
    selector_dg1,
    selector_older_than,
    tree,
    majority,
    passportNoAndNationalitySMT,
    nameAndDobSMT,
    nameAndYobSMT,
    selector_ofac,
    disclosures.excludedCountries ?? [],
    userIdentifierHash.toString()
  );
  return {
    inputs,
    circuitName: passportData.documentCategory === "passport" ? "vc_and_disclose" : "vc_and_disclose_id",
    endpointType: selfApp.endpointType,
    endpoint: selfApp.endpoint
  };
}
function getSelectorDg1(document, disclosures) {
  switch (document) {
    case "passport":
      return getSelectorDg1Passport(disclosures);
    case "id_card":
      return getSelectorDg1IdCard(disclosures);
  }
}
function getSelectorDg1Passport(disclosures) {
  const selector_dg1 = Array(88).fill("0");
  Object.entries(disclosures).forEach(([attribute, reveal]) => {
    if (["ofac", "excludedCountries", "minimumAge"].includes(attribute)) {
      return;
    }
    if (reveal) {
      const [start, end] = attributeToPosition[attribute];
      selector_dg1.fill("1", start, end + 1);
    }
  });
  return selector_dg1;
}
function getSelectorDg1IdCard(disclosures) {
  const selector_dg1 = Array(90).fill("0");
  Object.entries(disclosures).forEach(([attribute, reveal]) => {
    if (["ofac", "excludedCountries", "minimumAge"].includes(attribute)) {
      return;
    }
    if (reveal) {
      const [start, end] = attributeToPosition_ID[attribute];
      selector_dg1.fill("1", start, end + 1);
    }
  });
  return selector_dg1;
}
function generateTEEInputsKycDisclose(secret, kycData, selfApp, getTree) {
  const { scope, disclosures, endpoint, userId, userDefinedData, chainID } = selfApp;
  const userIdentifierHash = calculateUserIdentifierHash(chainID, userId, userDefinedData);
  const scope_hash = hashEndpointWithScope(endpoint, scope);
  const mapDisclosuresToKycFields = (config) => {
    const mapping = [
      ["issuing_state", "ADDRESS"],
      ["nationality", "COUNTRY"],
      ["name", "FULL_NAME"],
      ["passport_number", "ID_NUMBER"],
      ["date_of_birth", "DOB"],
      ["gender", "GENDER"],
      ["expiry_date", "EXPIRY_DATE"]
    ];
    return mapping.filter(([key]) => config[key]).map(([_, field]) => field);
  };
  const ofac_trees = getTree("kyc", "ofac");
  if (!ofac_trees) {
    throw new Error("OFAC trees not loaded");
  }
  if (!ofac_trees.nameAndDob || !ofac_trees.nameAndYob) {
    throw new Error("Invalid OFAC tree structure: missing required fields");
  }
  const nameAndDobSMT = new SMT2(poseidon25, true);
  const nameAndYobSMT = new SMT2(poseidon25, true);
  nameAndDobSMT.import(ofac_trees.nameAndDob);
  nameAndYobSMT.import(ofac_trees.nameAndYob);
  const serialized_tree = getTree("kyc", "commitment");
  const tree = LeanIMT2.import((a, b) => poseidon25([a, b]), serialized_tree);
  const inputs = generateKycDiscloseInputFromData(
    kycData.serializedApplicantInfo,
    secret,
    nameAndDobSMT,
    nameAndYobSMT,
    tree,
    disclosures.ofac ?? false,
    scope_hash,
    userIdentifierHash.toString(),
    mapDisclosuresToKycFields(disclosures),
    disclosures.excludedCountries,
    disclosures.minimumAge
  );
  return {
    inputs,
    circuitName: "vc_and_disclose_kyc",
    endpointType: selfApp.endpointType,
    endpoint: selfApp.endpoint
  };
}
async function generateTEEInputsRegister(secret, passportData, dscTree, env) {
  if (passportData.documentCategory === "aadhaar") {
    const { inputs: inputs2, circuitName: circuitName2, endpointType: endpointType2, endpoint: endpoint2 } = await generateTEEInputsAadhaarRegister(
      secret,
      passportData,
      dscTree,
      env
    );
    return { inputs: inputs2, circuitName: circuitName2, endpointType: endpointType2, endpoint: endpoint2 };
  }
  if (passportData.documentCategory === "kyc") {
    const inputs2 = await generateKycRegisterInput(
      passportData.serializedApplicantInfo,
      passportData.signature,
      [passportData.pubkey[0].toString(), passportData.pubkey[1].toString()],
      secret
    );
    return {
      inputs: inputs2,
      circuitName: getCircuitNameFromPassportData(passportData, "register"),
      endpointType: env === "stg" ? "staging_celo" : "celo",
      endpoint: "https://self.xyz"
    };
  }
  const inputs = generateCircuitInputsRegister(
    secret,
    passportData,
    dscTree
  );
  const circuitName = getCircuitNameFromPassportData(passportData, "register");
  const endpointType = env === "stg" ? "staging_celo" : "celo";
  const endpoint = "https://self.xyz";
  return { inputs, circuitName, endpointType, endpoint };
}
export {
  generateCircuitInputsRegister,
  generateTEEInputsAadhaarDisclose,
  generateTEEInputsAadhaarRegister,
  generateTEEInputsDSC,
  generateTEEInputsDiscloseStateless,
  generateTEEInputsKycDisclose,
  generateTEEInputsRegister
};
//# sourceMappingURL=registerInputs.js.map